import { devicesKo } from '@mangovoice/devices-ui'
import { extensionsKo } from '@mangovoice/extensions-ui'
import { hotelsKo } from '@mangovoice/hotels-ui'
import { messagingKo } from '@mangovoice/messaging-ui'
import { musicOnHoldKo } from '@mangovoice/music-on-hold-ui'
import { pbxLocationsKo } from '@mangovoice/pbx-locations-ui'
import { pbxSettingsKo } from '@mangovoice/pbx-settings-ui'
import { phoneNumbersKo } from '@mangovoice/phone-numbers-ui'
import { soundClipsKo } from '@mangovoice/soundclips-ui'
import { systemSettingsKo } from '@mangovoice/system-settings-ui'
import { userGroupsKo } from '@mangovoice/user-groups-ui'
import { webhooksKo } from '@mangovoice/webhooks-ui'

import { en } from './en'
import { scheduleKo } from './schedule.ko'

export const ko = {
  translation: {
    'Welcome to React': `React 및 react-i18next에 오신 것을 환영합니다`,
    yesterday: `어제`,
    today: `오늘`,
    hour: `시간`,
    day: `일`,
    week: `주`,

    baseSettings: {
      profile: `프로필`,
      snippets: `스니펫`,
      phone: `전화`,
      fax: `팩스`,
      notifications: `알림`,
      audio: `오디오`,
      updates: `업데이트`,
      blockedNumbers: `차단된 번호`,
      integrations: `통합`,
      callCenter: `콜 센터`,
      experiments: `실험`,
      shortcutKeys: `단축키`,
      collapse: `접기`,
      expand: `펼치기`,
      new: `새로 만들기`,
      admin: `관리자`,
      closeAdmin: `관리자 닫기`,
      adminSections: `관리자 섹션`,
    },

    nav: {
      voicemail: `음성 메일`,
      calls: `통화`,
      missedCalls: `부재중 전화`,
      text: `문자`,
      messaging: `메시징`,
      fax: `팩스`,
      contacts: `연락처`,
      settings: `설정`,
      webPhone: `웹 전화`,
      reporting: `보고`,
      hotels: `호텔`,
      switchboard: `스위치보드`,
      devices: `장치`,
      extensions: `내선`,
      messagingGroups: `메시징 그룹`,
      soundClips: `사운드 클립`,
      musicOnHold: `대기 음악`,
      phoneNumbers: `전화번호`,
      locations: `위치`,
      pbxSettings: `PBX 설정`,
      schedules: `일정`,
      integrations: `통합`,
      systemSettings: `시스템 설정`,
      users: `사용자`,
      userGroups: `사용자 그룹`,
      apiAccess: `API 액세스`,
      developers: `개발자`,
      mainNavigation: `주 메뉴`,
      skipToMainContent: `본문으로 건너뛰기`,
      callAnalytics: `통화 분석`,
      status: `상태`,
    },

    users: {
      detail: {
        close: `사용자 세부 정보 닫기`,
        loadingUser: `사용자 로딩 중...`,
        pbxAssociations: {
          heading: `PBX 연결`,
          addToPbx: `PBX에 추가`,
          filterPlaceholder: `PBX 연결 필터링...`,
          filterAriaLabel: `PBX 연결 필터링`,
          empty: `이 사용자는 어떤 PBX에도 할당되어 있지 않습니다.`,
          noMatches: `검색 결과와 일치하는 PBX 연결이 없습니다.`,
        },
      },
      generalInfo: {
        heading: `사용자 정보`,
        copyCognitoKey: `"Cognito Key" 복사`,
        resetPassword: `비밀번호 재설정`,
        resetPasswordAria: `비밀번호 재설정`,
        editUserInformation: `사용자 정보 편집`,
        deactivateUser: `사용자 비활성화`,
        activateUser: `사용자 활성화`,
        username: `사용자 이름`,
        name: `이름`,
        role: `역할`,
        email: `이메일`,
        lastLoggedIn: `마지막 로그인`,
        created: `생성됨`,
        updated: `업데이트됨`,
      },
      pbxAssociationCard: {
        editAria: `{{pbxName}}의 연결 편집`,
        removeAria: `{{pbxName}}에서 {{userName}} 제거`,
        assignedExtensions: `할당된 내선`,
        faxEmail: `팩스 이메일`,
        faxNumber: `팩스 번호`,
        pin: `PIN`,
        faxTitle: `팩스 제목`,
      },
      phonePermissions: {
        heading: `전화 권한`,
        loading: `전화 권한을 불러오는 중...`,
        empty: `이 사용자는 어떤 전화 권한 그룹에도 할당되어 있지 않습니다.`,
        editAria: `{{pbxName}}의 전화 권한 편집`,
        noGroupsAssigned: `할당된 그룹이 없습니다.`,
      },
      pbxUserForm: {
        titleAdd: `PBX에 추가`,
        titleEdit: `PBX 연결 편집`,
        pbxLabel: `PBX`,
        pbxSearchPlaceholder: `이름으로 PBX 검색...`,
        pbxSearchAria: `이름으로 PBX 옵션 검색`,
        pbxSearching: `검색 중...`,
        pbxTypeToSearch: `PBX를 검색하려면 입력하세요...`,
        pbxNoMatches: `검색 결과와 일치하는 PBX가 없습니다.`,
        faxTitleLabel: `팩스 제목`,
        faxTitlePlaceholder: `팩스 제목`,
        sendingFaxEmailLabel: `팩스 발신 이메일`,
        sendingFaxEmailPlaceholder: `팩스 이메일 주소`,
        invalidEmail: `유효한 이메일 주소를 입력하세요.`,
        sendingFaxNumberLabel: `팩스 발신 번호`,
        faxNumberSearchPlaceholder: `팩스 번호 검색...`,
        faxNumberSelectPbxFirst: `먼저 PBX를 선택하세요`,
        faxNumberSearchAria: `팩스 발신 번호 옵션 검색`,
        faxNumbersLoading: `팩스 번호를 불러오는 중...`,
        faxNumbersEmpty: `이 PBX의 팩스 번호를 찾을 수 없습니다.`,
        pinLabel: `PIN`,
        pinPlaceholder: `4자리 PIN (1000-9999)`,
        userGroupsLabel: `사용자 그룹`,
        userGroupsSelected_one: `{{count}}개 선택됨`,
        userGroupsSelected_other: `{{count}}개 선택됨`,
        cancel: `취소`,
        submitAdd: `PBX에 추가`,
        submitEdit: `변경사항 저장`,
      },
      editPhonePermissions: {
        title: `전화 권한 편집: {{userName}}`,
        pbxLabel: `PBX: {{pbxName}}`,
        groups: `그룹`,
        noGroups: `이 PBX에 사용할 수 있는 그룹이 없습니다.`,
        required: `(필수)`,
        selectedCount: `{{total}}개 중 {{selected}}개 선택됨`,
        close: `닫기`,
        submit: `전화 권한 업데이트`,
      },
      formatAssignedAssets: {
        extension_one: `할당된 내선 {{count}}개`,
        extension_other: `할당된 내선 {{count}}개`,
        device_one: `할당된 장치 {{count}}개`,
        device_other: `할당된 장치 {{count}}개`,
        and: ` 및 `,
      },
      toast: {
        userCreated: {
          title: `사용자 생성됨`,
          description: `{{firstName}} {{lastName}}이(가) 생성되었습니다.`,
        },
        userCreateError: {
          title: `사용자 생성 오류`,
        },
        userUpdated: {
          title: `사용자 업데이트됨`,
        },
        userUpdateError: {
          title: `사용자 업데이트 오류`,
        },
        pbxAdded: {
          title: `PBX에 사용자 추가됨`,
        },
        pbxUpdated: {
          title: `PBX 연결 업데이트됨`,
        },
        error: `오류`,
        associationRemoved: {
          title: `연결 제거됨`,
          description: `{{name}}이(가) 이 PBX에서 제거되었습니다.`,
        },
        alreadyRemoved: {
          title: `이미 제거됨`,
          description: `이 PBX에서 사용자를 찾을 수 없으며 이미 제거되었을 수 있습니다.`,
        },
        removeFailed: `PBX에서 사용자를 제거하지 못했습니다.`,
        noPhonePermissionChanges: {
          title: `전화 권한 변경 사항 없음`,
        },
        phonePermissionsUpdated: {
          title: `전화 권한이 업데이트됨`,
        },
        updateGroupFailed: `"{{name}}"을(를) 업데이트하지 못했습니다.`,
        phonePermissionsUpdateError: {
          title: `전화 권한을 업데이트하지 못했습니다`,
          fallback: `전화 권한을 업데이트할 수 없습니다.`,
        },
        defaultUserName: `사용자`,
      },
      removeDialog: {
        cannotTitle: `PBX에서 사용자를 제거할 수 없습니다`,
        thisUserCapitalized: `이 사용자`,
        cannotBody: `<bold>{{userName}}</bold>에게 이 PBX에 {{assets}}이(가) 있습니다. PBX에서 이 사용자를 제거하기 전에 이러한 자산을 재할당하거나 삭제하세요.`,
        ok: `확인`,
        confirmTitle: `PBX에서 사용자를 제거하시겠습니까?`,
        thisUser: `이 사용자`,
        confirmBody: `선택한 PBX에서 <bold>{{userName}}</bold>을(를) 제거합니다.`,
        cancel: `취소`,
        remove: `제거`,
      },
      list: {
        title: `사용자`,
        searchPlaceholder: `이름, 사용자 이름 또는 이메일로 검색...`,
        searchAriaLabel: `사용자 검색`,
        newUser: `새 사용자`,
        newUserAriaLabel: `새 사용자 만들기`,
        newUserDisabledAriaLabel: `새 사용자 만들기 (비활성화됨)`,
        newUserPermissionTooltip: `사용자를 만들 권한이 없습니다`,
        clickToCopy: `클릭하여 복사`,
        copied: `복사됨!`,
        loading: `사용자 로딩 중...`,
        error: `오류`,
        emptyNoResultsTitle: `결과를 찾을 수 없습니다`,
        emptyNoResultsDescription: `검색어를 조정해 보세요`,
        emptyNoUsersTitle: `아직 사용자가 없습니다`,
        emptyNoUsersDescription: `첫 번째 사용자를 만들어 시작하세요`,
        removeFromPbxTitle: `PBX에서 {{name}} 제거`,
        removeFromPbxDescription: `이 사용자에게 할당된 장치나 내선이 있으면 선택한 사용자에게 재할당됩니다.`,
        reassignAndRemove: `재할당 및 제거`,
        cancel: `취소`,
        reassignAssetsTo: `자산 재할당 대상`,
        selectUserPlaceholder: `사용자를 선택하세요...`,
        searchingUsers: `검색 중...`,
        noMatchingUsers: `일치하는 사용자가 없습니다`,
        searchUsersToReassign: `자산을 재할당할 사용자 검색`,
        candidateLoadFailed: `사용자를 불러올 수 없습니다. 연결을 확인한 후 다시 시도하세요.`,
        noOtherUsersOnPbx: `이 PBX에 다른 사용자가 없습니다. 이 사용자를 제거하기 전에 다른 사용자를 추가하여 자산을 재할당할 수 있도록 하세요.`,
        defaultUserName: `사용자`,
        column: {
          name: `이름`,
          usernameOrEmail: `사용자 이름 / 이메일`,
          role: `역할`,
          faxEmail: `팩스 이메일`,
          lastLogin: `마지막 로그인`,
          lastUpdated: `마지막 업데이트`,
          action: `작업`,
        },
        pagination: {
          resultsPerPage: `페이지당 결과:`,
          previousPage: `이전 페이지`,
          nextPage: `다음 페이지`,
          jumpToPage: `{{page}}페이지로 이동`,
          all: `전체`,
          recordRange: `{{start}}—{{end}} / 총 {{total}}개`,
          recordRangeEmpty: `0 / 0`,
        },
      },
      resetPassword: {
        toast: {
          copiedTitle: `재설정 링크가 클립보드에 복사되었습니다`,
          copyFailedTitle: `재설정 링크가 생성되었지만 복사하지 못했습니다`,
          manualCopyDescription: `이 재설정 URL을 수동으로 복사하세요: {{url}}`,
          missingUrlTitle: `재설정 링크를 생성하지 못했습니다`,
          missingUrlDescription: `재설정 URL이 반환되지 않았습니다.`,
          requestFailedTitle: `비밀번호 재설정에 실패했습니다`,
          unexpectedErrorDescription: `예기치 않은 오류가 발생했습니다.`,
        },
      },
      create: {
        loadingForm: `사용자 양식을 불러오는 중...`,
      },
      edit: {
        loadingDetails: `사용자 세부 정보를 불러오는 중...`,
        retryLoadingRoles: `역할 다시 불러오기`,
      },
      form: {
        heading: {
          newUser: `새 사용자`,
          editUser: `사용자 편집`,
        },
        section: {
          pbxAssignment: `PBX 할당`,
        },
        field: {
          firstName: `이름`,
          lastName: `성`,
          username: `사용자 이름`,
          usernameHelper: `필수. 4~150자. 문자, 숫자, 마침표, 하이픈만 사용할 수 있습니다. 참고: 사용자 이름은 생성 후 변경할 수 없습니다.`,
          email: `이메일`,
          emailHelper: `선택 사항. 한 번 설정한 이메일은 변경할 수 없습니다.`,
          isStaff: `Mango 직원입니까?`,
          staffHelperIntro: `이 권한은 몇 가지 예외를 제외하고 시스템에 대한 전체 액세스 권한을 부여합니다:`,
          staffHelperBullet1: `다른 사용자에게 Mango 슈퍼유저 권한을 부여할 수 없습니다.`,
          staffHelperBullet2: `Mango 슈퍼유저를 수정할 수 없습니다.`,
          staffHelperBullet3: `서버, 공급자 또는 기기 제조사를 수정할 수 없습니다.`,
          isSuperuser: `Mango 슈퍼유저`,
          role: `역할`,
          rolePlaceholder: `------`,
          roleUnavailable: `역할 옵션을 사용할 수 없음`,
          roleUnavailableHelper: `역할 옵션을 사용할 수 없습니다.`,
          roleWarning: `경고: 이 역할은 사용자가 속한 모든 PBX에 적용됩니다. 변경하기 전에 영향을 신중히 고려하세요.`,
          pbx: `PBX`,
          pbxSearchPlaceholder: `이름으로 PBX 검색...`,
          pbxSearchAriaLabel: `이름으로 PBX 옵션 검색`,
          pin: `PIN`,
          pinPlaceholder: `4자리 PIN (1000-9999)`,
          faxTitle: `팩스 제목`,
          faxTitlePlaceholder: `팩스 제목`,
          sendingFaxEmail: `팩스 발신 이메일`,
          sendingFaxEmailPlaceholder: `팩스 이메일 주소`,
          sendingFaxNumber: `팩스 발신 번호`,
          searchFaxNumbers: `팩스 번호 검색...`,
          selectPbxFirst: `먼저 PBX를 선택하세요`,
          searchFaxNumbersAriaLabel: `팩스 발신 번호 옵션 검색`,
          userGroups: `사용자 그룹`,
        },
        combobox: {
          searching: `검색 중...`,
          typeToSearchPbx: `PBX를 검색하려면 입력하세요...`,
          noPbxMatches: `검색 결과와 일치하는 PBX가 없습니다.`,
          loadingFaxNumbers: `팩스 번호를 불러오는 중...`,
          noFaxNumbers: `이 PBX의 팩스 번호를 찾을 수 없습니다.`,
        },
        userGroups: {
          placeholder: `사용자 그룹 선택...`,
          searchPlaceholder: `사용자 그룹 필터링...`,
          emptyLabel: `이 PBX에 사용할 수 있는 사용자 그룹이 없습니다.`,
          noResultsLabel: `필터와 일치하는 사용자 그룹이 없습니다.`,
          summary_one: `{{count}}개 그룹 선택됨`,
          summary_other: `{{count}}개 그룹 선택됨`,
        },
        button: {
          cancel: `취소`,
          saveAndCreateAnother: `저장 후 다른 사용자 만들기`,
          createUser: `사용자 만들기`,
          saveChanges: `변경사항 저장`,
        },
      },
    },

    switchboard: {
      list: {
        title: `스위치보드`,
        subtitle: `음성 시스템용 통화 흐름을 만들고 관리합니다`,
        newSwitchboard: `새 스위치보드`,
        search: { placeholder: `이름으로 검색...` },
        pagination: {
          resultsPerPage: `페이지당 결과:`,
          previousPage: `이전 페이지`,
          nextPage: `다음 페이지`,
          jumpToPage: `{{page}}페이지로 이동`,
          all: `전체`,
        },
        grid: {
          errorTitle: `오류`,
          errorLoading: `스위치보드를 불러오는 중 오류:`,
          checkConsole: `자세한 내용은 콘솔을 확인하세요`,
          loading: `스위치보드 불러오는 중...`,
        },
        empty: {
          noDataTitle: `아직 스위치보드가 없습니다`,
          noDataDescription: `첫 번째 스위치보드를 만들어 시작하세요`,
          noResultsTitle: `이 페이지에 스위치보드가 없습니다`,
          noResultsDescription: `페이지 크기를 조정하거나 다른 페이지로 이동해 보세요`,
          noSearchResultsTitle: `결과를 찾을 수 없습니다`,
          noSearchResultsDescription: `검색어를 조정해 보세요`,
        },
        card: {
          editAria: `스위치보드 편집`,
          deleteAria: `삭제`,
          lastUpdated: `마지막 업데이트`,
        },
        delete: {
          title: `스위치보드 삭제`,
          body: `"{{displayName}}"을(를) 삭제하시겠습니까? 이 작업은 실행 취소할 수 없습니다.`,
          cancel: `취소`,
          confirm: `삭제`,
        },
        deleteSuccessToast: `스위치보드가 삭제되었습니다`,
        deleteFailedToast: `스위치보드 삭제에 실패했습니다`,
        edit: {
          title: `스위치보드 편집`,
          nameLabel: `이름`,
          namePlaceholder: `예: 스위치보드 - 7074`,
          numberLabel: `번호`,
          numberPlaceholder: `예: 7074`,
          omitFromDirectoryLabel: `디렉터리에서 제외`,
          omitNo: `아니요`,
          omitYes: `예`,
          cancel: `취소`,
          submit: `스위치보드 업데이트`,
        },
      },
      edit: {
        loading: `스위치보드 불러오는 중...`,
        notFound: {
          title: `스위치보드를 찾을 수 없음`,
          errorLoading: `스위치보드를 불러오는 중 오류: {{message}}`,
          description: `확장 {{extensionDialPlan}}에 해당하는 스위치보드가 API에 없습니다.`,
          thisCouldMean: `다음과 같은 의미일 수 있습니다:`,
          reasonDeleted: `스위치보드가 삭제됨`,
          reasonNoData: `확장은 존재하지만 스위치보드 데이터가 없음`,
          reasonCorrupted: `데이터가 복구할 수 없을 정도로 손상됨`,
          backToList: `← 스위치보드 목록으로 돌아가기`,
          unknownError: `알 수 없는 오류`,
        },
        save: {
          cannotSave: `스위치보드를 저장할 수 없습니다`,
          success: `스위치보드가 저장되었습니다`,
          failed: `스위치보드 저장에 실패했습니다`,
          requiredFieldError: `{{node}}: {{message}}`,
          unexpectedError: `예기치 않은 오류가 발생했습니다.`,
          targetMismatch: `불러온 스위치보드가 현재 페이지와 일치하지 않습니다. 저장하기 전에 새로고침하세요.`,
        },
        header: {
          backToList: `스위치보드 목록으로 돌아가기`,
          defaultName: `스위치보드 {{extensionDialPlan}}`,
          deleteSwitchboard: `스위치보드 삭제`,
          save: `저장`,
          revertLocalChanges: `로컬 변경사항 되돌리기`,
          refreshSwitchboard: `스위치보드 새로고침`,
        },
        oldFormat: {
          warning: `⚠️ 경고: 스위치보드 데이터가 이전 형식입니다`,
          description: `이 스위치보드는 이전 편집기로 만들었습니다. 새 형식으로 마이그레이션할 때까지 시각적 흐름을 표시할 수 없습니다.`,
        },
        routeConflict: {
          title: `라우팅 충돌`,
          description: `{{node}} → {{route}}에 여러 대상이 연결되어 있습니다. 저장하기 전에 하나를 제거하세요.`,
        },
        unconfiguredSchedule: {
          description: `이 통화 흐름의 일정 노드에 일정이 선택되지 않았습니다. 저장하기 전에 일정을 선택하거나 노드 연결을 해제하세요.`,
          descriptionPlural: `이 통화 흐름의 일정 노드 {{count}}개에 일정이 선택되지 않았습니다. 저장하기 전에 각 노드에 일정을 선택하거나 연결을 해제하세요.`,
        },
        canvas: {
          emptyTitle: `아직 흐름이 구성되지 않았습니다`,
          emptyDescription: `"노드 추가"를 클릭하여 통화 흐름 구성을 시작하세요`,
          validationToastTitle: `경고!`,
          invalidConnection: `잘못된 연결`,
        },
        unsavedChanges: {
          title: `저장하지 않은 변경 사항`,
          body: `저장하지 않은 변경 사항이 있습니다. 나가시겠습니까?`,
          stay: `머무르기`,
          save: `저장`,
          leave: `나가기`,
        },
        revert: {
          title: `로컬 변경사항을 되돌릴까요?`,
          body: `이 브라우저 세션에서 변경한 내용을 제거하고 마지막으로 저장한 스위치보드를 다시 불러옵니다. 이미 저장된 내용은 삭제되지 않습니다.`,
          cancel: `취소`,
          confirm: `변경사항 되돌리기`,
          success: `로컬 변경사항을 되돌렸습니다`,
          successDescription: `마지막으로 저장한 스위치보드를 복원했습니다.`,
        },
        versionConflict: {
          title: `새 업데이트를 사용할 수 있습니다`,
          body: `다른 사용자가 이 스위치보드에 변경사항을 저장했습니다. 현재 편집을 유지하거나 최신 저장 버전을 불러오세요.`,
          keepWorking: `내 변경사항 유지`,
          loadLatest: `최신 변경사항 불러오기`,
        },
        refresh: {
          newerVersionTitle: `스위치보드 새로고침 완료`,
          newerVersionDescription: `더 최신으로 저장된 버전을 감지하여 불러왔습니다.`,
        },
        configPanel: {
          title: `{{type}} 구성`,
          notImplemented: `이 노드 유형에 대한 구성 UI는 아직 구현되지 않았습니다.`,
          cancel: `취소`,
          save: `저장`,
        },
      },
      nodeLabels: {
        start: `시작`,
        transfer: `전달`,
        transfer_and_continue: `전달 및 계속`,
        queue: `대기열`,
        auto_attendant: `자동 안내`,
        external_transfer: `외부 전달`,
        leave_voicemail: `음성 사서함에 남기기`,
        schedule: `일정`,
        day_night: `주간/야간`,
        dial_by_name: `이름으로 걸기`,
        sound_clip: `사운드 클립`,
        wait: `대기`,
        hang_up: `통화 종료`,
        jump_to_switchboard: `스위치보드로 이동`,
        conference_room: `회의실`,
        transfer_and_rollover: `전달 및 롤오버`,
        call_distribution: `통화 배포`,
        change_caller_id: `발신자 ID 변경`,
        webhook: `웹훅`,
        interactive_webhook: `대화형 웹훅`,
        fax_detect: `팩스 감지`,
        sms_notification: `SMS 알림`,
        ai_agent_v1: `AI 에이전트`,
      },
      dialogs: {
        deleteNode: {
          title: `노드 삭제`,
          body: `이 노드를 삭제하시겠습니까?`,
          bodyWithLabel: `"{{label}}"을(를) 삭제하시겠습니까?`,
          warning: `이 작업은 실행 취소할 수 없습니다. 이 노드에 대한 모든 연결도 제거됩니다.`,
          cancel: `취소`,
          confirm: `삭제`,
        },
        deleteEdge: {
          title: `연결 삭제`,
          body: `이 연결을 삭제하시겠습니까?`,
          warning: `이 작업은 실행 취소할 수 없습니다.`,
          cancel: `취소`,
          confirm: `삭제`,
        },
        deleteSwitchboard: {
          title: `스위치보드 삭제`,
          body: `이 스위치보드를 삭제하시겠습니까?`,
          bodyWithName: `"{{name}}"을(를) 삭제하시겠습니까?`,
          bodyWithId: `스위치보드 {{id}}을(를) 삭제하시겠습니까?`,
          warning: `이 작업은 실행 취소할 수 없습니다. 모든 스위치보드 구성 및 데이터가 영구적으로 삭제됩니다.`,
          cancel: `취소`,
          confirm: `삭제`,
        },
      },
      core: {
        selectExtension: `확장 선택...`,
        extensionLabel: `확장`,
        selectSchedule: `일정 선택...`,
        scheduleLabel: `일정`,
        selectSoundClip: `사운드 클립 선택...`,
        soundClipLabel: `사운드 클립`,
        selectSwitchboard: `스위치보드 선택...`,
        switchboardLabel: `스위치보드`,
        selectConferenceRoom: `회의실 선택...`,
        conferenceRoomLabel: `회의실`,
        selectQueue: `대기열 선택...`,
        queueLabel: `대기열`,
        selectFax: `팩스 확장 선택...`,
        faxLabel: `팩스 확장`,
        timeoutPlaceholder: `제한 시간(초)`,
        timeoutIncrease: `제한 시간 늘리기`,
        timeoutDecrease: `제한 시간 줄이기`,
        expand: `펼치기`,
        minimize: `최소화`,
        deleteNodeAria: `노드 삭제`,
        drop: `놓기`,
        drag: `끌기`,
        unnamed: `이름 없음`,
        voicemailOptions: {
          definedByExtension: `확장에서 정의`,
          systemGenerated: `시스템 생성 인사말`,
          noGreeting: `인사말 없음`,
          busy1: `통화중-1`,
          unavailable2: `이용 불가-2`,
          custom3: `사용자 지정-3`,
          custom4: `사용자 지정-4`,
          custom5: `사용자 지정-5`,
          custom6: `사용자 지정-6`,
          custom7: `사용자 지정-7`,
          custom8: `사용자 지정-8`,
          custom9: `사용자 지정-9`,
        },
      },
      create: {
        nameRequired: `이름 필요`,
        nameRequiredDescription: `이 스위치보드의 이름을 입력하세요.`,
        invalidNumber: `잘못된 번호`,
        invalidNumberDescription: `올바른 번호를 입력하세요.`,
        invalidNumberRange: `번호는 0이거나 100에서 99999 사이여야 합니다.`,
        pbxIdRequired: `PBX ID 필요`,
        pbxIdRequiredDescription: `스위치보드를 만들려면 PBX ID가 필요합니다.`,
        createdSuccess: `스위치보드가 생성되었습니다`,
        createFailed: `스위치보드 생성에 실패했습니다`,
        genericError: `오류가 발생했습니다`,
        cannotAddSwitchboard: `'{{name}}' 스위치보드를 추가할 수 없습니다`,
        extensionAlreadyExists: `'{{number}}' 번호의 확장이 이미 존재합니다.`,
        dialogTitle: `새 스위치보드`,
        close: `닫기`,
        submitButton: `새 스위치보드 만들기`,
      },
      nodes: {
        clickToConfigure: `구성하려면 클릭`,
        defaultLabel: `노드`,
        none: `없음`,
        transfer: {
          extension: `확장`,
          extensionHelp: `통화를 전환할 확장`,
          timeout: `제한 시간(초)`,
          timeoutHelp: `다음 노드로 진행하기 전 초 단위 제한 시간`,
          onInvalid: `잘못된 경우`,
          onInvalidHelp: `확장이 잘못된 경우 이동할 노드`,
          onTimeout: `제한 시간인 경우`,
          onTimeoutHelp: `전환이 제한 시간인 경우 이동할 노드`,
        },
        wait: {
          duration: `지속 시간(초)`,
          selectDuration: `지속 시간 선택...`,
          ringDuringWait: `대기 중 울림`,
        },
        hangUp: {
          noConfig: `이 노드는 통화를 종료합니다. 구성이 필요하지 않습니다.`,
          labelOptional: `레이블`,
          labelPlaceholder: `표시용 레이블`,
        },
        smsNotification: {
          missedCall: `부재 중 전화`,
          custom: `사용자 지정`,
          messageType: `메시지 유형`,
          message: `메시지`,
          messagePlaceholder: `부재 중 전화 {CALLER_ID}-{CALLER_NUMBER}`,
          tooltipNotesTitle: `참고`,
          tooltipNotesAria: `SMS 메시지 정보`,
          tooltip: {
            intro: `자체 메시지를 만들고 Mango 값을 포함하세요. 예: John Doe 발신자 ID가 있는 888-555-1212의 수신 전화는 다음과 같이 입력됩니다`,
            exampleTemplate: `부재 중 전화 {CALLER_ID}-{CALLER_NUMBER}`,
            exampleResultLeadIn: `이렇게 하면 SMS 수신자에게 다음과 같이 표시되는 SMS 메시지가 전송됩니다`,
            exampleResult: `부재 중 전화 John Doe-8885551212`,
            variablesHeading: `변수`,
          },
          smsRecipient: `SMS 수신자`,
          smsRecipientInfo: `SMS 수신자 정보`,
          separateNumbersHint: `쉼표로 번호를 구분하여 여러 수신자에게 보냅니다`,
          or: `또는`,
          autoReplyToCaller: `발신자에게 자동 응답`,
          sendFrom: `발신`,
          selectSendFrom: `번호 선택...`,
          selectMessagingGroup: `메시징 그룹 선택...`,
          smsGroupLabel: `SMS 그룹:`,
          currentUnavailableNumber: `현재 값(사용 불가): {{value}}`,
          incomingCall: `수신 전화`,
          voicemail: `음성 사서함`,
        },
        queue: {
          onEscape: `이스케이프 시`,
          maxWait: `최대 대기:`,
        },
        transferAndRollover: {
          noAnswer: `무응답`,
          busy: `통화중`,
        },
        common: {
          remove: `제거`,
          addOption: `+ 옵션 추가`,
          removeOption: `옵션 제거`,
          tooltip: {
            variablesHeading: `변수`,
            callerIdDesc: `통화하는 사람의 발신자 ID 이름`,
            callerNumberDesc: `통화하는 사람의 번호`,
            numberDialedDesc: `발신된 번호`,
            callUidDesc: `나중에 통화 기록을 조회하는 데 사용할 수 있는 통화의 고유 ID입니다.`,
            dialedNumberNameDesc: `발신된 번호의 mango 이름`,
            timeUtcDesc: `UTC 시간대의 통화 시간`,
          },
        },
        schedule: {
          open: `열림`,
          closed: `닫힘`,
          holiday: `휴일`,
        },
        aiAgent: {
          agentId: `에이전트 ID`,
          agentIdPlaceholder: `UUID 입력(36자)`,
          onError: `오류 시`,
          selectAgent: `에이전트 선택...`,
          noAgents: `구성된 에이전트 없음`,
        },
        externalTransfer: {
          transferCompany: `통화 전환 회사`,
          noCompany: `--`,
          searchTransferCompany: `통화 전환 회사 검색...`,
          searchTransferCompanyAriaLabel: `통화 전환 회사 검색`,
          noTransferCompanyMatches: `검색과 일치하는 통화 전환 회사가 없습니다.`,
          number: `번호`,
          enterPhoneNumber: `전화 번호 입력`,
          phoneNumberExactDigitError: `전화번호는 정확히 {{count}}자리여야 합니다`,
          phoneNumberDigitRangeError: `전화번호는 {{min}}~{{max}}자리여야 합니다`,
          sipServer: `SIP 서버`,
          enterSipServer: `SIP 서버 입력`,
          passThroughCallerId: `발신자 ID 통과`,
          orUseThisCallerId: `또는 이 발신자 ID 사용`,
          selectCallerId: `발신자 ID 선택...`,
          noPhoneNumbersAvailable: `사용 가능한 전화 번호 없음`,
          requireOneToConnect: `연결하려면 1 필요`,
        },
        callDistribution: {
          weight: `가중치`,
          weightWarning: `경고! 총 가중치 백분율은 100이어야 합니다. 현재 {{total}}`,
        },
        changeCallerId: {
          callerId: `발신자 ID`,
          enterCallerId: `발신자 ID 입력`,
          addUpTo20Chars: `앞에 최대 20자 추가`,
          replaceCallerId: `발신자 ID 바꾸기`,
        },
        dialByName: {
          invalid: `잘못됨`,
          lookupBy: `검색 기준`,
          extensionName: `확장 이름`,
          userName: `사용자 이름`,
          sortOrder: `정렬 순서`,
          firstName: `이름`,
          lastName: `성`,
          firstLastName: `이름/성`,
        },
        leaveVoicemail: {
          message: `메시지`,
        },
        autoAttendant: {
          repeatTimes: `반복 횟수`,
          allowExtensionDialing: `확장 다이얼 허용`,
          press: `누르기`,
        },
        dayNight: {
          whenOpen: `열림 시`,
          whenClosed: `닫힘 시`,
          open: `열림`,
          closed: `닫힘`,
          pressToToggle: `(전환하려면 {{code}} 누르기)`,
          basic: `기본`,
          advanced: `고급`,
          toggleCode: `전환 코드`,
          toastSuccess: `PBX 주/야 상태가 성공적으로 업데이트되었습니다`,
          toastFailed: `PBX 주/야 상태 업데이트에 실패했습니다`,
        },
        webhook: {
          tooltipTitle: `수행할 작업?`,
          tooltipAria: `웹훅 정보`,
          notifyUrl: `알림 URL`,
          notifyUrlPlaceholder: `http://www.example.com/mango_notification.php`,
          tooltip: {
            intro: `외부 웹사이트 또는 서버에 알림을 보내려면 이 기능을 사용하세요`,
            exampleUsesHeading: `사용 예:`,
            exampleUse1: `화면 팝업 알림`,
            exampleUse2: `통화 기록`,
            exampleUse3: `다른 사이트에서 작업 실행`,
            exampleUse4: `리드 생성`,
            exampleUrlHeading: `예시 URL`,
            curlyBracketsNote: `중괄호는 MangoVoice에서 실제 데이터로 대체됩니다.`,
          },
        },
        interactiveWebhook: {
          tooltipAria: `대화형 웹훅 정보`,
          url: `URL`,
          urlPlaceholder: `http://www.example.com/webhook`,
          allowExtensionAsOption: `옵션으로 확장 허용`,
          option: `옵션`,
          optionPlaceholder: `옵션`,
          tooltip: {
            intro: `대화형 웹훅을 사용하면 Mango와 소프트웨어 간 실시간 라우팅이 가능합니다.`,
            howItWorksHeading: `작동 방식:`,
            howItWorksBody: `Mango는 정의된 URL로 GET 요청을 보냅니다. 모든 {} 변수를 실제 데이터로 대체합니다. 요청의 매개변수를 사용하여 발신자 라우팅 방법을 결정할 수 있습니다. Mango가 통화를 라우팅할 옵션으로 응답을 보내면 됩니다. 이를 통해 발신자의 실시간 라우팅이 가능합니다.`,
            exampleCasesHeading: `예시 사례:`,
            exampleCase1: `기술 기반 라우팅`,
            exampleCase2: `초기 통화를 처리한 상담원에게 고객 다시 라우팅`,
            exampleCase3: `재방문 발신자를 위한 통화 경로 사용자 지정.`,
            exampleRequestHeading: `예시 요청`,
            responseNote: `응답의 옵션 값은 이 개체에 설정된 옵션과 일치해야 하며, 확장 번호도 반환할 수 있습니다.`,
            exampleResponseHeading: `예시 응답`,
            exampleResponseBody: `{"status": "success", "option": "1"}`,
          },
        },
      },
    },

    schedule: scheduleKo,

    global: {
      close: `닫기`,
      clearSearch: `검색어 지우기`,
      tooltip: {
        copyLink: `클립보드에 링크 복사`,
        copyLinkAt: `{{timeStamp}}에 링크 복사`,
        copyLinkText: `링크 복사`,
      },
      toast: {
        moveSuccess: `음성 메일이 성공적으로 이동되었습니다.`,
        moveError: `음성 메일을 이동하지 못했습니다.`,
        deleteSuccess: `음성 메일이 성공적으로 삭제되었습니다.`,
        deleteError: `음성 메일을 삭제하지 못했습니다.`,
        markUnreadSuccess: `음성 메일이 읽지 않음으로 표시되었습니다.`,
        markUnreadError: `음성 메일을 읽지 않음으로 표시하지 못했습니다.`,
        copyLinkSuccess: `링크가 클립보드에 복사되었습니다.`,
        copySuccess: `클립보드에 복사됨`,
        copyError: `클립보드에 복사할 수 없습니다.`,
        extensionSwitched: `내선 번호가 다음으로 전환되었습니다:`,
        pbxChanged: `PBX가 다음으로 변경되었습니다:`,
        globalPhoneHotKeySuccess: `전글로벌 전화 단축키가 성공적으로 저장되었습니다.`,
        globalPhoneHotKeyError: `전글로벌 전화 단축키를 저장하지 못했습니다.`,
        globalPhoneHotKeyDisabled: `단축키가 비활성화되었습니다.`,
        globalPhoneHotKeyEnabled: `단축키가 활성화되었습니다.`,
      },
      input: {
        defaultPlaceholder: `여기에 입력하세요`,
      },
      timeAgo: {
        justNow: `방금`,
        minutesAgo_one: `{{count}}분 전`,
        minutesAgo_other: `{{count}}분 전`,
        hoursAgo_one: `{{count}}시간 전`,
        hoursAgo_other: `{{count}}시간 전`,
        daysAgo_one: `{{count}}일 전`,
        daysAgo_other: `{{count}}일 전`,
      },
      currency: {
        default: `{{value, currency}}`,
        withCode: `{{value, currency, currencyCode}}`,
      },
    },

    contactSearchInput: {
      placeholder: `이름 또는 번호 입력`,
      invalidPhoneNumber: `유효하지 않은 전화번호`,
      noNumber: `번호 없음`,
    },

    newCallModal: {
      header: `새 통화`,
      sendToWebPhone: `웹 전화로 보내기`,
      sendToDeskPhone: `데스크 전화(Yealink)로 보내기`,
      from: `보낸 사람`,
      to: `받는 사람`,
      answerHandsetWhenItRings: `전화기가 울리면 수화기를 드십시오.`,
      attemptingToEstablishCallTo: `{{phoneNumber}}으로 통화 연결 시도 중...`,
      checkInternetConnection: `인터넷 연결을 확인하고 다시 시도하십시오.`,
      tryAgain: `다시 시도`,
      establishingCallTo: `{{phoneNumber}}으로 통화 연결 중...`,
      failedToEstablishCallTo: `{{phoneNumber}}으로 통화 연결에 실패했습니다.`,
    },

    confirmBlockNumberModal: {
      title: `{{formattedPhoneNumber}} 차단`,
      message: `PBX는 이 번호로부터 더 이상 전화, 문자 또는 팩스를 받지 않습니다.`,
      confirmText: `번호 차단`,
      cancelText: `취소`,
      toastBlockError: `{{formattedPhoneNumber}}을(를) 차단하는 데 문제가 발생했습니다. 다시 시도하십시오.`,
      toastUnblockError: `{{formattedPhoneNumber}}을(를) 차단 해제하는 데 문제가 발생했습니다. 다시 시도하십시오.`,
    },

    blockedNumbers: {
      addNumber: `번호 추가`,
      headerSubtext: `아래 나열된 번호로부터의 모든 전화, 문자 및 팩스는 차단됩니다.`,
      header: `차단된 번호`,
      clearButton: `지우기`,
      blockButton: `번호 차단`,
      modalSubtext: `아래 나열된 번호로부터의 모든 전화, 문자 및 팩스는 차단됩니다.`,
      noBlockedNumbers: `차단된 번호가 없습니다.`,
      unblockTooltip: `차단 해제`,
      unblockNumberLabel: `{{formattedPhoneNumber}} 차단 해제`,
      numberUnblocked: `{{formattedPhoneNumber}} 차단이 해제되었습니다`,
      confirmUnblock: {
        title: `{{formattedPhoneNumber}} 차단을 해제하시겠습니까?`,
        message: `PBX가 이 번호로부터 전화, 문자 및 팩스를 다시 받게 됩니다.`,
        confirmText: `번호 차단 해제`,
        cancelText: `취소`,
      },
    },
    a11y: {
      messages: {
        senderContact: `연락처`,
        senderYou: `나`,
        senderTeam: `팀`,
        messageMeta: `{{sender}}, {{time}}:`,
        newMessage: `{{sender}}의 새 메시지: {{body}}`,
        newMessages: `{{sender}}의 새 메시지 {{count}}개`,
        attachment: `첨부 파일`,
        messageSent: `메시지를 보냈습니다`,
        messageFailed: `메시지를 보내지 못했습니다. 다시 시도할 수 있습니다.`,
        openImage: `이미지 열기 {{name}}`,
        imageFrom: `{{sender}}의 이미지`,
        downloadFile: `{{name}} 다운로드`,
      },
      composer: {
        label: `메시지`,
        labelWithName: `{{name}}에게 메시지`,
      },
      toast: {
        close: `닫기`,
      },
      nav: {
        notificationCount: `새 항목 {{count}}개`,
      },
      filterGroup: {
        text: `문자 필터`,
        voicemail: `음성 메일 필터`,
        fax: `팩스 필터`,
        snippets: `스니펫 필터`,
      },
      recipient: {
        label: `받는 사람 이름 또는 번호`,
        listLabel: `추천 연락처`,
        results: `찾은 연락처: {{count}}개`,
      },
    },

    messageInput: {
      statusMessage: {
        uploading: `업로드 중...`,
        failedToUpload: `업로드 실패`,
      },
      attachMedia: `미디어 첨부`,
      addSnippet: `스니펫 추가`,
      emojis: `이모티콘 😃`,
      sendText: `문자 보내기`,
      inputPlaceholder: `여기에 메시지를 보내세요`,
      retry: `재시도`,
    },

    messagingPage: {
      emptyDetailViewMessage: `선택된 스레드 없음`,
      errorToastMessage: `유효하지 않은 전화번호`,
      textPlaceholder: {
        receivedFile: `수신된 파일`,
        fileSent: `파일 전송됨`,
      },
      subheadingText: `{{phoneNumber, phone}} 발신`,
    },

    newFaxModal: {
      header: `새 팩스`,
      footer: {
        sendButtonText: `보내기`,
      },
      loadingView: {
        sendingFax: `팩스 전송 중...`,
      },
    },

    newFaxForm: {
      dropdownPlaceholder: `발신...`,
      textAreaPlaceholder: `표지 메모 입력`,
      switchText: {
        includeCoverPage: `표지 포함`,
        sendEmailConfirmation: `이메일 확인 보내기`,
      },
      dropzonePlaceholder: `최대 25MB 팩스 전송 가능`,
      tagInputPlaceholder: `이메일 주소를 입력하고 "Enter"를 누르세요`,
      tagInputGuideText: `최대 {{maxEmailConfirmations}}개의 이메일 주소를 제출할 수 있습니다.`,
      coverPageNoteLabel: `표지 메모`,
      emailConfirmationsLabel: `확인 이메일`,
      emailValueType: `이메일`,
    },

    sizeGauge: {
      totalSize: `총 크기: {{totalSize}} / {{sizeLimit}}`,
      exceededSize: `초과: {{exceededSize}}`,
    },

    contentDefault: {
      placeholder: `여기에 파일을 끌어다 놓거나 클릭하여 찾아보기`,
    },

    contentAcceptedMulti: {
      previewFile: `{{fileName}} 미리 보기`,
      removeFile: `{{fileName}} 제거`,
      fileRemoved: `{{fileName}} 제거됨`,
      moveUp: `{{fileName}} 위로 이동`,
      moveDown: `{{fileName}} 아래로 이동`,
      fileMoved: `{{fileName}}을(를) {{total}}개 중 {{position}}번째로 이동함`,
      possibleDuplicate: `중복 가능성`,
      tooLarge: `너무 큼`,
      possibleDuplicateAndTooLarge: `중복 가능성 및 너무 큼`,
      fileWithStatus: `{{file}} ({{status}})`,
    },

    newThreadModal: {
      header: {
        newThread: `새 스레드`,
        noGroupFound: `그룹을 찾을 수 없습니다.`,
      },
      sendButtonText: `보내기`,
      contactText1: `이 내선 번호는 메시징 그룹에 속하지 않습니다.`,
      contactText2: `{{adminUrl}}으로 이동하여 메시징 그룹을 설정하거나 Mango 관리자에게 문의하십시오.`,
      contactLinkText: `메시징 그룹이란 무엇입`,
      placeholder: `메시지`,
    },

    deleteConfirmModal: {
      title: `음성 메일 삭제?`,
      message: `영구적으로 삭제되며 되돌릴 수 없습니다.`,
      deleteButton: `삭제`,
      cancelButton: `취소`,
    },

    confirmModal: {
      defaultTitle: `확실합니까?`,
      confirmDeleteVoicemail: `이 음성 메일을 삭제하면 영구적으로 삭제되며 되돌릴 수 없습니다.`,
      dontAskAgain: `다시 묻지 않기`,
    },

    emptySearch: {
      shoot: `아차.`,
      nothingIsMatching: `일치하는 항목이 없습니다.`,
      didYouSpellItRight: `올바르게 입력하셨습니까?`,
    },

    listItem: {
      unreadStatus: `읽지 않음`,
      markedAsUnread: `읽지 않음으로 표시됨`,
      markedAsRead: `읽음으로 표시됨`,
    },

    messageThreadHeader: {
      rename: `이름 변경`,
      cancel: `취소`,
      threadNameLabel: `대화 이름`,
    },

    dropZoneMappings: {
      fileToLarge: {
        title: `파일이 너무 큼`,
        description: `업로드하려는 파일이 너무 큰 것 같습니다. 최대 파일 크기는 {{maxFileSize}}MB입니다.`,
      },
      fileInvalidType: {
        link: `더 알아보기`,
        title: `지원되지 않는 파일 형식`,
        faxDescription: `해당 파일은 지원되지 않는 파일 형식인 것 같습니다. 지원되는 파일 형식에 대해 {{link}}하십시오.`,
        description: `해당 파일은 지원되지 않는 파일 형식인 것 같습니다. 지원되는 파일 형식에 대해 {{urlLink}}에서 자세히 알아보십시오.`,
      },
      fileUploadFailed: {
        title: `업로드 실패`,
        description: `업로드하려는 파일이 업로드되지 않은 것 같습니다. 다시 시도하십시오.`,
      },
      general: {
        title: `예상치 못한 오류가 발생했습니다.`,
        description: `예상치 못한 오류가 발생했습니다. 다시 시도하십시오.`,
      },
    },

    messageThreads: {
      emptyState: {
        title: `문자 없음`,
        subtitle1: `아직 문자 메시지를 보내거나 받지 못했습니다.`,
        subtitle2: `시작하려면 문자를 보내십시오.`,
      },
      searchPlaceholder: `이름 또는 번호 검색`,
      searchLabel: `메시지 검색`,
      allGroups: `모든 그룹`,
      new: `{{count}}개 새 항목 - 모두 보기`,
      markAllRead: `모두 읽음으로 표시`,
      buttonText: `새 문자`,
    },

    phoneOptions: {
      recent: `최근`,
      missed: `부재 중`,
    },

    chatOptions: {
      recent: `최근`,
      unread: `읽지 않음`,
    },

    snippetOptions: {
      pbx: `PBX`,
      personal: `개인`,
    },

    chatMenu: {
      label: `스니펫`,
      settings: `스니펫 설정`,
    },

    phoneMenu: {
      label: `자동 응답`,
    },

    generalMenu: {
      label: `피드백 보내기`,
    },

    experimentsMenu: {
      label: `웹 전화`,
    },

    developMenu: {
      notifications: `알림`,
      contacts: `연락처`,
    },

    callState: {
      inboundAnswered: `수신 통화 응답됨`,
      outboundAnswered: `발신 통화 응답됨`,
      inboundMissedOrDeclined: `수신 통화 부재 중 또는 거절됨`,
      outboundMissedOrDeclined: `발신 통화 부재 중 또는 거절됨`,
    },

    voicemailState: {
      received: `음성 메일 수신`,
      sent: `음성 메일을 남겼습니다.`,
    },

    voicemailOptions: {
      recent: `최근`,
      unread: `읽지 않음`,
    },

    mangoPhoneTypes: {
      mobile: `모바일`,
      work: `직장`,
      home: `집`,
    },

    mangoContactTypes: {
      mango: `Mango Voice`,
    },

    markReadModal: {
      header: `주의 - 모두 읽음으로 표시`,
      message: `모든 스레드를 읽음으로 표시하는 것은 취소할 수 없습니다.`,
      confirmText: `확실합니까?`,
      confirmButton: `확인`,
    },

    faxViewList: {
      titleNoFaxes: `팩스 없음`,
      titleNoMatchingFaxes: `일치하는 팩스 없음`,
      subtitleTryRemovingFilters: `일부 필터를 제거해 보십시오.`,
      subtitleNoFaxes: `팩스가 없는 것 같습니다.`,
      buttonTextStartFax: `팩스 시작`,
      buttonTextStartFirstFax: `첫 팩스 시작`,
      searchPlaceholder: `이름 또는 번호 검색`,
      searchLabel: `팩스 검색`,
      status: {
        failed: `실패`,
        pending: `처리 중`,
        sent: `보냄`,
        received: `받음`,
        unknown: `알 수 없음`,
      },
    },

    pdfToolbar: {
      print: `인쇄`,
      download: `다운로드`,
      openInNewTab: `새 탭에서 열기`,
      firstPage: `첫 페이지`,
      previousPage: `이전 페이지`,
      nextPage: `다음 페이지`,
      lastPage: `마지막 페이지`,
      rotate: `회전`,
      pageStatus: `{{pages}}페이지 중 {{pageNumber}}페이지`,
    },

    toolbar: {
      clearAll: `모두 지우기`,
      potentialDuplicates: `잠재적 중복`,
    },

    call: {
      toast: {
        callDeclined: `{{context}}로부터의 전화가 거절되었습니다.`,
        callEnded: `{{context}}과의 통화가 종료되었습니다.`,
        callHeld: `{{context}}과의 통화가 보류되었습니다.`,
        callParked: `{{callName}}이(가) {{parkingLotName}}에 주차되었습니다.`,
        callParkFailed: `{{callName}}을(를) {{parkingLotName}}에 보류하지 못했습니다`,
        callTargetUndialable: `{{target}}(으)로 전화할 수 없습니다 - 번호를 확인하고 다시 시도하세요`,
        callTransferred: `{{callName}}이(가) {{transferToName}}(으)로 전송되었습니다.`,
        callTransferFailed: `{{callName}}을(를) {{transferToName}}(으)로 전환하지 못했습니다`,
        callUnavailable: `전화가 연결되지 않음 - 전화를 걸 수 없습니다`,
      },
    },

    incomingCallModal: {
      newCallFrom: `새 통화 발신:`,
      rejectCall: `통화 거절`,
      acceptCall: `통화 수락`,
      endAndAccept: `종료 및 수락`,
      holdAndAccept: `보류 및 수락`,
      parkAndAccept: `주차 및 수락`,
    },

    popupCallButtons: {
      accept: `수락`,
      reject: `거부`,
      endAndAccept: `종료 후 수락`,
      holdAndAccept: `보류 후 수락`,
      parkAndAccept: `대기 후 수락`,
      switch: `전환`,
      resume: `재개`,
      end: `종료`,
      tooltip: {
        accept: `수신 통화 수락`,
        reject: `수신 통화 거부`,
        endAndAccept: `현재 통화를 종료하고 수신 통화 수락`,
        holdAndAccept: `현재 통화를 보류하고 수신 통화 수락`,
        parkAndAccept: `현재 통화를 대기시키고 수신 통화 수락`,
        switch: `이 통화로 전환`,
        resume: `이 통화 재개`,
        end: `이 통화 종료`,
      },
    },

    callStatus: {
      deskPhone: `데스크 전화`,
      onHold: `보류 중`,
      ringing: `벨소리`,
      connected: `연결됨`,
      connecting: `연결 중`,
      ready: `준비됨`,
      dialing: `발신 중...`,
      reconnecting: `재연결 중...`,
      onDeskPhone: `데스크 전화 사용 중`,
      connectedWithDuration: `연결됨 {{duration}}`,
      shortDial: `발신`,
      shortRing: `벨`,
      shortHold: `보류`,
      shortConn: `연결`,
      shortDesk: `데스크`,
    },

    callAnnouncements: {
      incomingCall: `수신 전화: {{name}}, {{number}}`,
      incomingCallNameOnly: `수신 전화: {{name}}`,
      connected: `연결됨`,
      onHold: `보류 중`,
      resumed: `통화 재개됨`,
      muted: `음소거됨`,
      unmuted: `음소거 해제됨`,
      callEnded: `통화 종료됨`,
      answerFailed: `전화를 받지 못했습니다`,
      holdFailed: `통화를 보류하지 못했습니다`,
      resumeFailed: `통화를 재개하지 못했습니다`,
    },

    callSoundIndicator: {
      onHold: `보류 중`,
      muted: `음소거됨`,
      reconnecting: `재연결 중`,
    },

    popup: {
      tabs: {
        inboundCalls: `수신 전화`,
        messages: `메시지`,
      },
      emptyStates: {
        noCalls: {
          title: `전화를 찾을 수 없습니다`,
          description: `현재 수신 전화가 없습니다`,
        },
        noActiveCalls: `활성 통화 없음`,
        noMessages: {
          title: `메시지를 찾을 수 없습니다`,
          description: `현재 메시지가 없습니다`,
        },
      },
      footer: {
        poweredByMango: `Mango Voice 제공`,
      },
      callButtons: {
        deskPhoneActive: `데스크 전화에서 통화 중`,
        dismiss: `무시`,
      },
      callItem: {
        unknownCaller: `알 수 없는 발신자`,
        unknownNumber: `알 수 없는 번호`,
        onHold: `보류 중`,
        pageIntercom: `호출/인터콤`,
        callDetails: `통화 세부 정보`,
      },
      messageButtons: {
        dismiss: `무시`,
        openMessage: `메시지 열기`,
      },
      personCard: {
        patientFile: `환자 파일`,
        fullName: `성명`,
        dateOfBirth: `생년월일`,
        patientNumber: `환자 번호`,
        inboundNumber: `수신 번호`,
        extension: `내선`,
        defaultLocation: `기본 위치`,
        nextAppointment: `다음 예약`,
        previousAppointment: `이전 예약`,
        insurance: `보험`,
        balance: `잔액`,
      },
      header: {
        expand: `확장`,
        minimize: `최소화`,
        dismiss: `무시`,
        logoAlt: `로고`,
      },
    },

    faxPage: {
      toast: {
        copyLinkSuccess: `링크가 클립보드에 복사되었습니다.`,
        copyLinkError: `링크를 클립보드에 복사하지 못했습니다.`,
        sendSuccess: `팩스가 대기열에 추가되었으며 곧 전송됩니다.`,
        sendError: `팩스를 보내는 데 문제가 발생했습니다. 다시 시도하십시오.`,
        deleteSuccess: `팩스가 성공적으로 삭제되었습니다.`,
        deleteError: `이 팩스를 삭제하는 데 문제가 발생했습니다. 다시 시도하십시오.`,
        unexpectedError: `예기치 않은 오류가 발생했습니다`,
      },
      confirmDelete: {
        title: `팩스 삭제`,
        message: `이 팩스를 삭제하시겠습니까?`,
        button: `삭제`,
        cancel: `취소`,
      },
      confirmResend: {
        title: `팩스 재전송`,
        message: `이 팩스를 재전송하시겠습니까?`,
        button: `재전송`,
        cancel: `취소`,
      },
      emptyStateMessage: `선택된 팩스 없음`,
      status: {
        queued: `대기 중`,
        received: `수신됨`,
        sent: `보냄`,
      },
      direction: {
        to: `받는 사람`,
        from: `보낸 사람`,
      },
      detailsHeader: {
        status: `{{statusDate}} {{statusTime}} {{directionText}}에 {{statusPrefix}}`,
      },
    },

    secureFaxPage: {
      logoAlt: `Mango Voice logo`,
      loading: {
        title: `보안 팩스 링크 확인 중`,
        description: `보안 팩스 링크를 확인하는 동안 잠시 기다려 주세요.`,
      },
      password: {
        title: `보안 팩스 액세스`,
        description: `이 보안 팩스에 액세스하려면 보안 팩스 비밀번호를 입력하세요.`,
        label: `보안 팩스 비밀번호`,
        placeholder: `비밀번호 입력`,
        submitButton: `보안 팩스 보기`,
        submittingButton: `비밀번호 확인 중...`,
      },
      errors: {
        password_required: `비밀번호가 필요합니다.`,
        invalid_password: `입력한 비밀번호가 올바르지 않습니다.`,
        s3_error: `보안 팩스 미리보기를 준비할 수 없습니다. 다시 시도하세요.`,
        throttled: `요청이 너무 많습니다. 잠시 후 다시 시도하세요.`,
        unknown: `문제가 발생했습니다. 다시 시도하세요.`,
        attemptsRemaining: `남은 시도 횟수: {{count}}`,
      },
      status: {
        expired: {
          title: `링크 만료됨`,
          description: `이 보안 팩스 링크가 만료되었습니다. 새 보안 팩스 링크를 요청하세요.`,
        },
        disabled: {
          title: `링크 비활성화됨`,
          description: `이 보안 팩스 링크가 비활성화되었습니다.`,
        },
        not_found: {
          title: `링크를 찾을 수 없음`,
          description: `이 보안 팩스 링크를 찾을 수 없습니다.`,
        },
        max_downloads_reached: {
          title: `다운로드 한도 도달`,
          description: `이 보안 팩스 링크가 최대 다운로드 횟수에 도달했습니다.`,
        },
        too_many_attempts: {
          title: `시도 횟수 초과`,
          description: `비밀번호 시도 횟수가 너무 많아 이 보안 팩스 링크가 잠겼습니다.`,
        },
        throttled: {
          title: `요청이 너무 많음`,
          description: `이 링크에 대한 요청이 너무 많습니다. 잠시 후 다시 시도하세요.`,
        },
        unknown: {
          title: `보안 팩스를 불러올 수 없음`,
          description: `이 보안 팩스 링크를 확인할 수 없습니다.`,
        },
        actions: {
          checkAgain: `다시 확인`,
        },
      },
      download: {
        title: `보안 팩스 준비 완료`,
        description: `보안 팩스가 준비되었습니다. 이 다운로드 링크는 곧 만료되므로 지금 다운로드하세요.`,
        detailsTitle: `팩스 상세 정보`,
        fromLabel: `발신`,
        toLabel: `받는 사람`,
        receivedLabel: `수신`,
        downloadsRemainingLabel: `남은 다운로드 횟수`,
        actions: {
          download: `팩스 다운로드`,
          openInNewTab: `새 탭에서 열기`,
          tryAnotherPassword: `다른 비밀번호 시도`,
        },
        fetchError: {
          title: `미리보기를 불러올 수 없음`,
          description: `다운로드 링크에서 보안 팩스 미리보기를 불러올 수 없습니다.`,
          retryPreview: `미리보기 다시 시도`,
          generic: `보안 팩스 미리보기를 불러오지 못했습니다.`,
        },
      },
    },

    voicemail: {
      emptyState: {
        title: `음성 메일 없음`,
        subtitle1: `모든 전화를 받고 계신 것 같습니다. 계속 잘하세요!`,
        subtitle2: `음성 메일이 누락된 것으로 생각되면 지원팀에 문의하십시오.`,
        buttonText: `지원팀에 문의`,
      },
      searchPlaceholder: `발신자 이름 또는 번호 검색`,
      searchLabel: `음성 메일 검색`,
      emptyDetailViewMessage: `선택된 음성 메일 없음`,

      mangoModal: {
        title: `이동`,
        headerText: `음성 메일 이동`,
        cancelButtonText: `취소`,
        moveButtonText: `음성 메일 이동`,
        selectVoicemailBoxText: `음성 메일 함 선택...`,
        markAsUnreadText: `선택한 함에서 읽지 않음으로 표시`,
        destinationBoxText: `대상 음성 메일 함`,
        destinationBoxWarning: `대상 음성 메일 함에 액세스할 수 없으면 이 음성 메일을 사용할 수 없게 됩니다.`,
      },

      detailView: {
        headerSubheadingText: `발신`,
        headerSubheadingToText: `받는 사람`,
        audioPlayerTitle: `음성 메일 오디오`,
        transcriptionText: `스크립트`,
      },

      loadingText: `음성 메일`,
      transcriptionTitleText: `스크립트`,

      move: {
        error: `음성 메일을 이동하는 동안 오류가 발생했습니다.`,
        success: `음성 메일이 성공적으로 이동되었습니다.`,
        successMarkAsUnread: `음성 메일이 성공적으로 이동되었고 읽지 않음으로 표시되었습니다.`,
        successMarkAsRead: `음성 메일이 성공적으로 이동되었습니다.`,
      },

      filter: {
        all: `모두`,
        unread: `읽지 않음`,
        allInboxes: `모든 받은 편지함`,
      },

      tooltip: {
        move: `이동`,
        delete: `삭제`,
        markAsUnread: `읽지 않음으로 표시`,
        markAsRead: `읽음으로 표시`,
        blockNumber: `번호 차단`,
        unblockNumber: `번호 차단 해제`,
        copyLink: `클립보드에 링크 복사`,
        editContact: `연락처 편집`,
        newCall: `새 통화`,
        newText: `새 문자`,
        resendFax: `팩스 재전송`,
        moveFax: `팩스 이동`,
        newFax: `새 팩스`,
        close: `닫기`,
      },

      copyLinkError: `링크를 클립보드에 복사하지 못했습니다.`,
    },

    audioPlayer: {
      rewind10s: `10초 뒤로 감기`,
      play: `재생`,
      pause: `일시 중지`,
      mute: `음소거`,
      unmute: `음소거 해제`,
      fastForward10s: `10초 앞으로 감기`,
      jumpToAnswer: `응답으로 이동`,
      changePlaybackSpeed: `재생 속도 변경`,
      downloadAudio: `오디오 다운로드`,
      seeKeyboardShortcuts: `키보드 단축키 보기`,
      mediaError: `이 오디오 파일을 로드하는 데 문제가 발생했습니다.`,
      noAudio: `녹음 사용 불가`,
      playbackPosition: `재생 위치`,
      playbackPositionValue: `{{duration}} 중 {{position}}`,
    },

    fax: {
      filter: {
        all: `모두`,
        unread: `읽지 않음`,
        allInboxes: `모든 받은 편지함`,
        sent: `보냄`,
        received: `받음`,
      },
      tooltip: {
        pending: `이 팩스는 처리 중이며 곧 전송됩니다.`,
      },
    },

    pbxPrompt: {
      loggingIn: `로그인 중...`,
      loadingPbxs: `PBX 로딩 중...`,
      selectPbx: `PBX를 선택하세요`,
      noPbxMessage: `현재 전화 시스템(PBX)의 회원이 아닙니다. 이 앱을 사용하려면 사무실에서 전화 시스템을 관리하는 사람에게 연락하여 추가해 달라고 요청하세요.`,
      noPbxErrorMessage: `오류라고 생각되시면 Mango 지원팀에 문의하여 추가 지원을 받으세요.`,
      callSupport: `지원팀에 전화하기`,
      emailSupport: `지원팀에 이메일 보내기`,
      back: `뒤로`,
      errorTitle: `앗! 문제가 발생했습니다.`,
      errorMessage: `다시 시도하거나 지원팀에 문의하세요.`,
    },

    pbxPicker: {
      searchPlaceholder: `PBX 검색...`,
      current: `현재`,
      recent: `최근`,
      allPbxs: `모든 PBX`,
      searchResults: `검색 결과`,
      noResults: `PBX를 찾을 수 없습니다`,
      searchPrompt: `이름으로 PBX 검색`,
      switchPbx: `PBX 전환`,
      count: `{{count}}개 PBX`,
      countFiltered: `{{count}}개 PBX 검색됨`,
    },

    pbxHeaderSwitcher: {
      selectPbx: `PBX 선택`,
      ariaLabel: `PBX 전환`,
    },

    loginPrompt: {
      loginFailedError: `로그인 실패. 다시 시도해 주세요.`,
      invalidEmail: `유효하지 않은 이메일 주소입니다!`,
      enterUsername: `사용자 이름을 입력하세요`,
      enterPassword: `비밀번호를 입력하세요`,
      invalidCredentials: `사용자 이름 또는 비밀번호가 올바르지 않습니다. 자격 증명을 확인하고 다시 시도하세요.`,
      usernamePlaceholder: `이메일 / 사용자 이름`,
      passwordPlaceholder: `비밀번호`,
      logIn: `로그인`,
      forgotPassword: `비밀번호를 잊으셨나요?`,
      openSupportForm: `지원 양식 열기`,
      backToLogin: `로그인으로 돌아가기`,
      showPassword: `비밀번호 표시`,
    },

    desktopAppBanner: {
      tryDesktopApp: `최고의 경험을 위해 {{appName}} 데스크톱 앱을 사용해 보세요`,
      desktopAppName: `{{appName}} 데스크톱`,
      launchAppTooltip: `설치된 경우 데스크톱 앱 실행`,
      downloadAppTooltip: `데스크톱 앱 다운로드`,
      launchApp: `앱 실행`,
      download: `다운로드`,
      settings: `설정`,
      dontAskAgain: `다시 묻지 않기`,
      remindMeLater: `나중에 알림`,
      alwaysOpenHint: `링크를 항상 데스크톱 앱에서 열려면 설정에서 변경하세요.`,
      launchConfirmTitle: `데스크톱 앱에서 열기`,
    },
    openApp: {
      title: `데스크톱 앱을 여는 중…`,
      subtitle: `지금 앱을 실행하고 있습니다. 자동으로 열리지 않으면 아래 버튼을 사용하세요.`,
      closeHint: `앱이 열리면 이 탭을 닫아도 됩니다.`,
      openButton: `데스크톱 앱 열기`,
      fallbackPrompt: `데스크톱 앱이 설치되어 있지 않나요?`,
      downloadButton: `데스크톱 앱 다운로드`,
    },

    openedInDesktop: {
      title: `이 페이지를 데스크톱 앱에서 열려고 시도했습니다`,
      subtitle: `{{appName}} 데스크톱 앱이 열렸다면 이 탭을 닫아도 됩니다.`,
      continueInBrowser: `브라우저에서 계속하기`,
      tryAgain: `다시 시도`,
      stopOpeningInDesktop: `데스크톱 앱에서 링크 열기 중지`,
      settingsHint: `링크를 이 브라우저에서 계속 열려면 <settingsLink>설정에서 데스크톱 앱 옵션</settingsLink>을 변경하세요.`,
    },

    profileSettings: {
      myProfile: `내 프로필`,
      editProfile: `프로필 편집`,
      name: `이름`,
      username: `사용자 이름`,
      email: `이메일`,
      openDesktopApp: `데스크톱 앱 열기`,
      launchDesktopApp: `데스크톱 앱 실행`,
      callSupport: `지원팀에 전화`,
      emailSupport: `지원 이메일`,
      sendFeedback: `피드백 보내기`,
      whatsNew: `새로운 기능`,
      downloadApp: `앱 다운로드`,
      logOut: `로그아웃`,
      needHelp: `도움이 필요하십니까?`,
      switchPbx: `PBX 전환`,
      pbxName: `PBX 이름`,
      darkMode: `다크 모드`,
      darkModeOptions: {
        light: `라이트`,
        dark: `다크`,
        system: `시스템 설정 사용`,
      },
      language: `언어`,
      desktopApp: {
        label: `데스크톱 앱`,
        beta: `베타`,
        modeLabel: `이 브라우저에서 {{appName}} 링크를 열 때`,
        modeHint: `이 설정은 이 브라우저에만 적용됩니다.`,
        modes: {
          ask: `물어보기(배너 표시)`,
          always: `항상 데스크톱 앱에서 열기`,
          never: `묻지 않기`,
        },
        testLaunch: {
          title: `데스크톱 앱에서 링크 열기`,
          question: `{{appName}} 데스크톱 앱을 열려고 시도했습니다. 앱이 열렸나요?`,
          yes: `예, 열렸습니다`,
          no: `아니요, 열리지 않았습니다`,
          notOpened: `링크는 계속 이 브라우저에서 열립니다. {{appName}} 데스크톱 앱을 설치한 후 다시 시도하세요.`,
          tryAgain: `다시 시도`,
          close: `닫기`,
        },
      },
      switchPbxConfirmation: {
        title: `현재 PBX 변경`,
        message: `이 애플리케이션에서는 다시 전환할 때까지 {{pbxName}}의 전화, 문자, 팩스 및 음성 메일을 사용할 수 없습니다.`,
        confirmText: `확인`,
        cancelText: `취소`,
      },
      editMyProfile: {
        title: `내 프로필 편집`,
        update: `프로필 업데이트`,
        close: `닫기`,
        firstName: `이름`,
        lastName: `성`,
        username: `사용자 이름`,
        email: `이메일`,
        errRequiredFirstName: `이름을 입력하세요.`,
        errRequiredLastName: `성을 입력하세요.`,
        successProfile: `프로필이 성공적으로 업데이트되었습니다.`,
      },
    },

    pbxQuerySwitch: {
      confirm: {
        title: `이 PBX로 설정하시겠습니까?`,
        message: `PBX를 {{pbxName}}(으)로 설정하시겠습니까?`,
        confirmText: `PBX 설정`,
        cancelText: `취소`,
      },
      warning: {
        invalid: {
          title: `유효하지 않은 PBX 링크`,
          description: `PBX 링크가 올바르지 않습니다. Admin에서 다시 시도해 주세요.`,
        },
        inaccessible: {
          title: `PBX를 전환할 수 없습니다`,
          description: `해당 PBX에 대한 접근 권한이 없습니다.`,
        },
      },
    },

    languageSelector: {
      title: `언어 기본 설정`,
      selectLanguage: `언어 선택`,
      autoDetect: `자동 감지 (시스템 언어)`,
      languages: {
        en: `영어`,
        'en-US': `영어 (미국)`,
        'en-GB': `영어 (영국)`,
        'en-CA': `영어 (캐나다)`,
        es: `스페인어`,
        'es-MX': `스페인어 (멕시코)`,
        'es-US': `스페인어 (미국)`,
        'fr-CA': `프랑스어 (캐나다)`,
        ko: `한국어`,
        ne: `네팔어`,
        te: `텔루구어`,
      },
    },

    snippetsSettings: {
      confirmationModal: {
        title: `확실합니까?`,
        message: `이 스니펫을 삭제하는 것은 영구적이며 되돌릴 수 없습니다.`,
        confirmText: `삭제`,
        cancelText: `취소`,
      },
      errorWithTimeout: `문제가 발생했습니다. 나중에 다시 시도하십시오.`,
      headerText: `스니펫`,
      newButtonText: `새로 만들기`,
      tooltipDelete: `삭제`,
      editSnippetLabel: `스니펫 {{name}} 편집`,
      deleteSnippetLabel: `스니펫 {{name}} 삭제`,
      cancelEditing: `편집 취소`,
      dismissError: `오류 닫기`,
      editSnippet: `스니펫 편집`,
      newSnippet: `새 스니펫`,
      shortcut: `단축키`,
      inputPlaceholder: `굿모닝`,
      shortcutGuideText: `한 단어, 공백 없음. 예: #good-morning 또는 #TestResults`,
      visibility: `가시성`,
      visibilityGuideText: `개인 = 나만 액세스 가능, 회사 = 모든 사람이 액세스 가능`,
      editBodyInputPlaceholder: `여기에 미리 정의된 메시지를 작성하십시오. 이메일, 웹 링크, 전화번호 등을 추가할 수 있습니다.`,
      mangoButtonCancel: `취소`,
      mangoButtonSave: `저장`,
      loadingSnippets: `스니펫 로드 중...`,
      noSnippetsFound: `스니펫을 찾을 수 없습니다.`,
      body: `본문`,
      personal: `개인`,
      filter: {
        all: `모두`,
        unread: `읽지 않음`,
        allInboxes: `모든 받은 편지함`,
      },
    },

    phoneSettings: {
      incomingCalls: `수신 통화`,
      showInboundC2CCalls: `수신 C2C 통화 표시`,
      playRingtone: `벨소리 재생`,
      ringtone: `벨소리`,
      respondWithBusyToSecondCall: `두 번째 통화에 통화 중으로 응답`,
      disabledInAgentMode: `상담원 모드가 활성화되면 비활성화됨`,
      outgoingCalls: `발신 통화`,
      defaultOutboundPhone: `발신 통화의 기본 전화 선택`,
      autoAnswer: `자동 응답`,
      enableCallerIdSelection: `발신자 ID 선택 활성화`,
      enableCallerIdSelectionDescription: `전화 걸 때 발신 전화번호를 선택할 수 있습니다.`,
      callerId: `발신자 ID`,
      presence: `재석`,
      presenceDescription: `다음 섹션은 웹 전화에 표시되어 가장 자주 다이얼한 내선 번호와 번호에 빠르게 액세스할 수 있습니다.`,
      parkingSpotsDisplayed: `표시된 주차 공간 (최대 5개)`,
      removeParkingSpot: `주차 공간 제거`,
      addParkingSpot: `주차 공간 추가`,
      lineExtensionsDisplayed: `표시된 회선 내선 (최대 10개)`,
      removeExtension: `내선 제거`,
      addExtension: `내선 추가`,
      speedDial: `단축 다이얼 (최대 {{maxSpeedDials}}개)`,
      editSpeedDial: `단축 다이얼 편집`,
      removeSpeedDial: `단축 다이얼 제거`,
      addSpeedDial: `단축 다이얼 추가`,
      clickToCall: `클릭 투 콜`,
      sendToDeskPhone: `데스크 전화(Yealink)로 보내기`,
      useWebPhone: `웹 전화 사용`,
    },

    phoneSettingItems: {
      selectExtension: `내선 번호 선택`,
      yourExtension: `내 내선 번호`,
      activateWebPhone: `웹 전화 활성화`,
      confirmationModal: {
        title: `사용 가능한 회선 내선 없음`,
        message1: `이 전화 시스템({{pbxName}})에 할당된 회선 내선이 없습니다.`,
        message2: `전화 기능을 사용하려면 시스템 관리자에게 문의하여 회선 내선을 할당하십시오.`,
        confirmText: `해제`,
        cancelText: `취소`,
      },
    },

    extensionSelector: {
      selectExtension: `새 내선 번호 선택`,
      deactivateWebPhone: `웹 전화 비활성화`,
      none: `없음`,
      confirmationModal: {
        title: `장치 연결 해제`,
        message: `이 장치는 더 이상 {{extensionName}}으로부터 전화를 보내거나 받지 않습니다.`,
        confirmText: `확인`,
        cancelText: `취소`,
      },
    },

    webPhone: {
      unknownCaller: `알 수 없는 발신자`,
      selectParkingSpot: `주차 위치 선택`,
      receivingCalls: `통화 수신 중`,
      doNotDisturb: {
        title: `방해 금지`,
        until: `{{time}}까지`,
        indefinite: `방해 금지`,
        for30Minutes: `30분간 방해 금지`,
        for1Hour: `1시간 동안 방해 금지`,
        for2Hours: `2시간 동안 방해 금지`,
        untilTomorrow: `내일까지 방해 금지`,
        turnOff: `방해 금지 해제`,
      },
      tooltip: {
        copied: `복사됨!`,
        copyCallerId: `발신자 ID 복사`,
        copyPhoneNumber: `전화번호 복사`,
        endCall: `통화 종료`,
        muteCall: `음소거`,
        answerCall: `통화 받기`,
        switchToCall: `통화 전환`,
        warmTransfer: `따뜻한 전환`,
        holdCall: `통화 대기`,
        resumeCall: `통화 재개`,
        newCall: `새 통화`,
        mergeCalls: `통화 병합`,
        endConference: `회의 종료`,
      },
      callError: {
        youAreDisconnected: `연결이 끊겼습니다`,
        connectionInterrupted: `연결이 중단되었습니다. 연결을 다시 시도하려면 여기를 클릭하세요.`,
        reconnect: `재연결`,
        connecting: `연결 중…`,
        connectionFailed: `전화 연결에 실패했습니다. 다시 시도하세요.`,
        retry: `다시 시도`,
        microphoneDisabled: `마이크 권한이 비활성화되었습니다!`,
        microphoneEnableText: `마이크 권한을 활성화하면 웹폰을 사용할 수 있습니다.`,
        microphoneInUse: `마이크가 사용 중입니다`,
        microphoneInUseText: `다른 애플리케이션이 마이크를 사용하고 있습니다. 해당 앱(예: Zoom, Teams 또는 다른 탭)을 닫고 다시 시도하세요.`,
        seeHereForHelp: `도움말은 여기를 참조하세요.`,
      },
      feedback: {
        reason: {
          soundDelayed: `소리가 지연되었습니다`,
          couldntHearOthers: `다른 사람의 소리가 들리지 않았습니다`,
          echo: `에코가 있었습니다`,
          audioBreakingUp: `오디오가 끊겼습니다`,
          othersCouldntHearMe: `다른 사람들이 제 소리를 듣지 못했습니다`,
          otherAudioIssue: `기타 오디오 문제`,
        },
        modal: {
          header: `무엇이 잘못되었나요?`,
          dismiss: `닫기`,
          submit: `피드백 제출`,
        },
        toast: {
          header: `통화 오디오를 평가하세요`,
          thanks: `감사합니다!`,
          goodQuality: `통화 품질 좋음`,
          poorQuality: `통화 품질 나쁨`,
          dismiss: `닫기`,
        },
      },
    },

    faxSettings: {
      enableFaxCoverPage: `팩스 표지 활성화`,
    },

    notificationSettings: {
      alertMessage: `알림을 차단했습니다. 브라우저 설정에서 다시 켜야 합니다.`,
      browserNotifications: `브라우저 알림`,
      playSoundForNewTexts: `새 문자 메시지에 소리 재생`,
      testNotification: `테스트 알림`,
      volumeControl: `알림 볼륨은 컴퓨터로 제어됩니다.`,
      help: `도움말`,
      helpLinkText: `알림을 켜고 끄는 방법`,
      onGoogleChrome: `Google Chrome에서?`,
      callPop: {
        title: `통화 및 문자 알림창`,
        description: `새로운 알림창 기능을 사용해 보세요. 이 기능은 전화나 문자 메시지를 받을 때 작고 별도의 창을 표시합니다. 이를 통해 작업 중단 없이 통화 및 문자 정보를 확인할 수 있습니다!`,
        answerOnPatientInfoButtonClick: `환자 정보 열 때 통화 응답`,
        showExampleButton: `예시 보기`,
        enableExampleHint: `예시 버튼을 활성화하려면 위의 스위치를 토글하세요`,
      },
      popupPosition: {
        title: `팝업 창 위치`,
        topLeft: `왼쪽 상단`,
        topRight: `오른쪽 상단`,
        bottomLeft: `왼쪽 하단`,
        bottomRight: `오른쪽 하단`,
      },
    },

    callInProgressModal: {
      title: `통화 중`,
      message: `내선을 전환하기 전에 현재 통화를 종료하세요`,
      dismiss: `닫기`,
    },

    sessionExpiredModal: {
      title: `세션이 만료되었습니다`,
      message: `보안을 위해 로그아웃되었습니다. 문자 메시지 임시 저장본은 이 기기에 보관됩니다. 계속하려면 다시 로그인하세요.`,
      signInAgain: `다시 로그인`,
    },

    audioSettings: {
      selectSoundOutputSource: `사운드 출력 소스 선택 - 스피커`,
      selectInputSource: `입력 소스 선택 - 마이크`,
      toSelectAudioDevices: `오디오 장치를 선택하려면 마이크 권한을 부여하십시오.`,
    },

    integrationsSettings: {
      title: `통합`,
      description: `이 페이지에는 일부 데이터 소스 통합이 표시됩니다 — Mango와 진료 관리 소프트웨어 간에 데이터를 동기화하는 연결입니다. 아직 여기에 표시되지 않는 다른 활성 통합이 있을 수 있습니다. 모든 것을 통합하는 통합 경험을 개발 중입니다.`,
      configuration: `구성`,
      auth: `인증`,
      authDescription: `이 통합은 데이터에 액세스하기 위해 인증이 필요합니다.`,
      authButton: `인증하기`,
      authRegionNotSupported: `감지된 지역에서는 인증을 사용할 수 없습니다. VPN을 사용하는 경우와 같이 이것이 잘못되었다고 생각되면 지원 팀에 문의하세요.`,
      agentId: `ID: {{id}}`,
      copiedConfirmation: `복사됨!`,
      copyIdFailedTitle: `ID를 복사할 수 없습니다`,
      unknownDate: `(알 수 없음)`,
      statusActive: `활성`,
      statusPaused: `일시 중지`,
      createdLabel: `생성됨`,
      updatedLabel: `업데이트됨`,
      notSet: `(설정 안 됨)`,
      enabled: `활성화됨`,
      disabled: `비활성화됨`,
      accessRestricted: `통합에 액세스할 권한이 없습니다. 액세스하려면 관리자에게 문의하세요.`,
      emptyState: {
        primary: `아직 여기에 관리되는 데이터 소스 통합이 없습니다.`,
        secondary: `활성 통합이 있는 경우 아직 이 목록에 나타나지 않을 수 있습니다.`,
      },
      error: {
        title: `통합 로드 실패`,
        message: `통합을 로드하는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요.`,
      },
    },

    updateSettings: {
      noExperimentsAvailable: `현재 실행 중인 실험이 없습니다.`,
      channelSwitcher: {
        title: `릴리스 채널 전환`,
        description: `받을 업데이트 버전을 선택하세요. 프로덕션은 가장 안정적인 기능을 제공하며, 다른 채널은 새로운 기능의 미리보기를 제공할 수 있습니다. 채널 전환 시 애플리케이션 재시작이 필요합니다.`,
        devModeNote: `개발 모드: 채널 전환이 시뮬레이션되며 앱을 재시작하는 대신 페이지를 새로고침합니다.`,
        releaseChannel: `릴리스 채널`,
        selectChannel: `채널 선택...`,
        switchChannel: `채널 전환`,
        rollback: `{{channelName}}(으)로 되돌리기`,
        current: `현재: {{channelName}}`,
        switchTo: `전환:`,
        error: `채널 사용 불가`,
        validationError: `{{channelName}}(으)로 전환할 수 없습니다. 채널이 아직 उपलब्ध하지 않거나 네트워크 문제가 있을 수 있습니다. 잠시 후 다시 시도해 주세요.`,
        switchFailed: `채널을 전환하지 못했습니다. 다시 시도하세요.`,
        restartModal: {
          title: `재시작 필요`,
          successMessage: `<strong>{{channelName}}</strong> 채널로 성공적으로 전환되었습니다.`,
          warningMessage: `채널 전환을 완료하려면 애플리케이션을 업데이트한 후 다시 시작해야 합니다. 저장하지 않은 작업은 손실됩니다.`,
          cancel: `취소`,
          restartNow: `전환 시작`,
          switchingChannel: `{{channelName}}(으)로 전환 중...`,
          checkingUpdates: `업데이트 확인 중...`,
          downloadingUpdate: `업데이트 다운로드 중... {{progress}}%`,
          activatingChannel: `채널 활성화 중...`,
          switching: `전환 중...`,
        },
        highRiskWarning: {
          title: `불안정한 채널`,
          description: `이 채널에는 실험적인 기능, 버그 또는 불완전한 기능이 포함될 수 있습니다. 사용에 따른 위험은 본인이 감수해야 합니다.`,
        },
        mediumRiskWarning: {
          title: `사전 릴리스 채널`,
          description: `이 채널에는 버그나 불완전한 기능이 있을 수 있는 사전 릴리스 소프트웨어가 포함되어 있습니다.`,
        },
      },
      releaseNotifications: {
        title: `릴리스 알림`,
        description: `앱의 새 버전이 릴리스되면 이메일을 받습니다.`,
        descriptionWithChannel: `{{channel}} 채널에 앱의 새 버전이 릴리스되면 이메일을 받습니다.`,
        toggleLabel: `새 릴리스에 대해 이메일 받기`,
        recipient: `알림은 계정에 연결된 이메일 주소로 전송됩니다.`,
        recipientWithEmail: `알림은 {{email}}(으)로 전송됩니다.`,
        resubscribeNote: `이전에 구독을 취소했습니다. 이 기능을 켜면 이메일이 릴리스 업데이트 이메일에 다시 구독됩니다.`,
        error: `알림 설정을 업데이트할 수 없습니다. 다시 시도해 주세요.`,
        loadError: `알림 설정을 불러올 수 없습니다.`,
        retry: `다시 시도`,
        previewButton: `이메일 미리 보기`,
        previewModalTitle: `릴리스 이메일 예시`,
        previewModalNote: `받게 될 이메일의 예시입니다. 실제 내용은 릴리스에 따라 다릅니다. 이메일은 영어로 발송됩니다.`,
        previewFrom: `보낸 사람:`,
        previewSubject: `제목:`,
        previewClose: `닫기`,
        previewTipsTitle: `이메일을 꼭 받아보세요`,
        previewSenderTip: `이메일 발신 주소:`,
        previewTipContacts: `해당 주소를 연락처나 주소록에 추가하세요.`,
        previewTipJunk: `릴리스 후 이메일이 보이지 않으면 스팸 또는 정크 폴더를 확인하고 "스팸 아님"으로 표시하세요.`,
        previewTipSafelist: `회사 계정의 경우 IT 관리자에게 mangovoice.com 도메인을 허용 목록에 추가하도록 요청하세요.`,
      },
    },

    blockedNumberModal: {
      header: `번호 차단`,
      description: `이 번호로부터의 모든 전화, 문자 및 팩스는 차단됩니다.`,
      clearButton: `지우기`,
      blockButton: `번호 차단`,
      inputPlaceholder: `전화번호 입력`,
      inputLabel: `차단할 전화번호`,
    },

    callCenterSettings: {
      enableAgentMode: `상담원 모드 활성화`,
      customStatuses: `사용자 지정 상담원 상태`,
      customStatusesDescription: `점심, 휴식, 회의 등 통화 대기열 외부 활동을 추적하기 위한 사용자 지정 상태를 설정하십시오. 팀 활동을 체계적으로 관리하고 볼 수 있도록 하십시오.`,
      editStatus: `상태 편집`,
      deleteStatus: `상태 삭제`,
      confirmationModal: {
        title: `사용자 지정 상태 삭제`,
        text1: `사용자 지정 상태, `,
        text2: `, 이(가) 영구적으로 삭제됩니다. 확실합니까?`,
        confirmText: `상태 삭제`,
        cancelText: `취소`,
      },
      newStatus: `새 상태`,
      toast: {
        deleteStatusSuccess: `상태가 성공적으로 삭제되었습니다.`,
      },
    },

    customStatusModal: {
      NameAddrHeader: `사용자 지정 상태 추가`,
      editHeader: `사용자 지정 상태 편집`,
      inputLabel: `상태 이름`,
      inputPlaceholder: `이름`,
      type: `유형`,
      typePlaceholder: `유형 선택`,
      away: `자리 비움`,
      online: `온라인`,
      description: `설명`,
      descriptionPlaceholder: `이 상태는 무엇에 사용됩니까?`,
      toast: {
        createSuccess: `상태가 성공적으로 생성되었습니다.`,
        editSuccess: `상태가 성공적으로 업데이트되었습니다.`,
      },
      cancelButton: `취소`,
      saveButton: `저장`,
    },

    experimentsState: {
      queueDashboardEnabled: `대기열 대시보드`,
      queueDashboardDescription: `대기열 대시보드 기능 활성화.`,
      missedCallsEnabled: `놓친 전화`,
      missedCallsDescription: `놓친 전화 추적 기능 활성화.`,
      badge: {
        beta: `베타`,
      },
      globalPhoneCapture: {
        title: `전역 전화번호 캡처`,
        description: {
          intro: `컴퓨터의 모든 애플리케이션에서 전화번호를 복사한 다음 단축키를 눌러 Mango Voice 다이얼패드에 해당 번호를 입력할 수 있습니다.`,
          howToUse: `이 기능 사용 방법: 먼저 아래에서 사용하려는 단축키 조합을 선택한 다음 "단축키 설정" 버튼을 누르세요.`,
          afterSet: `단축키가 설정되면 다른 애플리케이션에서 평소처럼 전화번호를 복사한 다음(Cmd/Ctrl+C 또는 컨텍스트 메뉴 사용) 선택한 단축키를 눌러 Mango Voice에 해당 번호를 로드하세요.`,
          note: `참고: 일부 단축키는 다른 애플리케이션에서 사용 중일 수 있습니다. Mango는 충돌을 감지하고 알려드립니다.`,
        },
        activeSettingTitle: `단축키 상태:`,
        activeAndSet: `현재 단축키`,
        unsavedChanges: `제안된 단축키:`,
        configureTitle: `단축키 구성:`,
        keyLabel: `키:`,
        status: {
          enabled: `활성화됨`,
          disabled: `비활성화됨`,
        },
        button: {
          setHotkey: `단축키 설정`,
          disableFeature: `단축키 비활성화`,
          enableFeature: `단축키 활성화`,
          clearHotkey: `단축키 지우기`,
        },
        notSet: `설정되지 않음`,
        toast: {
          hotkeyCleared: `단축키가 지워졌습니다`,
        },
      },
    },

    shortcutKeysHelp: {
      title: `오디오 플레이어 키보드 단축키`,
      keyboardKeys: {
        spaceBar: `스페이스 바`,
        m: `M`,
        leftArrow: `←`,
        rightArrow: `→`,
        slash: `/`,
        shift: `Shift`,
      },
      playPause: `재생 / 일시 중지`,
      muteUnmute: `음소거 / 음소거 해제`,
      rewind10s: `10초 뒤로 감기`,
      advance10s: `10초 앞으로 감기`,
      rewind3s: `3초 뒤로 감기`,
      advance3s: `3초 앞으로 감기`,
      scopeNote: `음소거 및 건너뛰기 단축키는 키보드 포커스가 오디오 플레이어에 있을 때 작동합니다.`,
    },

    newParkingLotModal: {
      header: `주차 공간 추가`,
      parkingSpot: `주차 공간`,
      label: `레이블`,
      cancelButton: `취소`,
      saveButton: `저장`,
      parking1Label: `주차 1`,
      parking2Label: `주차 2`,
      parking3Label: `주차 3`,
      parking4Label: `주차 4`,
      parking5Label: `주차 5`,
      parking6Label: `주차 6`,
      parking7Label: `주차 7`,
      parking8Label: `주차 8`,
      parking9Label: `주차 9`,
      parking10Label: `주차 10`,
    },

    newExtensionSubscriptionModal: {
      header: `내선 존재 추가`,
      extension: `내선`,
      cancelButton: `취소`,
      saveButton: `저장`,
    },

    dropdownSelect: {
      placeholder: `선택...`,
      noResultsFound: `결과를 찾을 수 없습니다`,
      assignUserFirst: `먼저 사용자를 할당하세요`,
    },

    tooltips: {
      filter: `필터`,
      dismiss: `닫기`,
      chartInformation: `차트 정보`,
    },

    form: {
      placeholder: {
        searchNameOrNumber: `이름 또는 번호 검색`,
        selectStatus: `상태 선택`,
        selectUser: `사용자 선택`,
        selectVirtualFax: `가상 팩스 선택...`,
        searchNumbers: `번호 검색`,
        dateMonth: `월`,
        dateDay: `일`,
        dateYear: `년`,
        timeHours: `시`,
        timeMinutes: `분`,
        timeMeridiem: `오전`,
      },
    },

    newSpeedDialModal: {
      addSpeedDial: `단축 다이얼 추가`,
      editSpeedDial: `단축 다이얼 편집`,
      contactName: `연락처 이름`,
      number: `번호`,
      cancelButton: `취소`,
      saveButton: `저장`,
    },

    actionsButton: {
      tooltipNewAction: `새 작업`,
      newThread: `새 스레드`,
      newCall: `새 통화`,
      newFax: `새 팩스`,
    },

    accountButton: {
      settings: `설정`,
      connectionStatus: `앱 상태`,
      switchPbx: `PBX 전환`,
      openApp: `앱 열기`,
      downloadApp: `앱 다운로드`,
      whatsNew: `새로운 기능`,
      giveFeedback: `피드백 제공`,
      helpCenter: `고객 센터`,
      logOut: `로그아웃`,
      apiDocs: `API 문서`,
    },

    statusPanel: {
      title: `앱 상태`,
      tabBasic: `기본`,
      tabAdvanced: `고급`,
      tabListLabel: `앱 상태 보기`,
      refresh: `새로 고침`,
      refreshing: `새로 고치는 중…`,
      refreshed: `업데이트됨`,
      close: `닫기`,
      copyDiagnostics: `진단 정보 복사`,
      copied: `복사됨`,
      overallHealthy: `정상`,
      overallDegraded: `저하됨`,
      overallDown: `중단됨`,
      overallIdle: `대기 중`,
      overallUnknown: `알 수 없음`,
      summaryGood: `모든 것이 정상입니다.`,
      summaryProblem: `문제가 발견되었습니다.`,
      fixNetworkOffline: `Wi-Fi 또는 네트워크 케이블을 확인한 후 다시 시도하세요.`,
      fixPhoneError: `페이지를 새로 고쳐 전화를 다시 연결하세요. 계속 실패하면 지원팀에 문의하세요.`,
      fixRealtimeReconnecting: `자동으로 다시 연결 중입니다. 계속되면 페이지를 새로 고치세요.`,
      fixRealtimeSuspended: `앱이 일시 중지되었습니다. 곧 다시 시작됩니다. 그렇지 않으면 새로 고치세요.`,
      fixRealtimeDisconnected: `메시지 및 통화 업데이트를 복원하려면 페이지를 새로 고치세요.`,
      rowInternet: `인터넷`,
      rowPhoneService: `전화 서비스`,
      rowMessaging: `메시지`,
      rowAppUpdates: `앱 업데이트`,
      stateUpdateReady: `업데이트 준비됨`,
      stateCantInstallUpdates: `업데이트를 설치할 수 없음`,
      stateUpdateBlocked: `업데이트 차단됨`,
      stateUpdateReadyVersion: `업데이트 준비됨 ({{version}})`,
      stateUpdateDownloading: `업데이트 다운로드 중…`,
      stateUpdateDownloadingVersion: `업데이트 다운로드 중 ({{version}})…`,
      stateUpdateCheckFailed: `업데이트를 확인할 수 없음`,
      stateCheckingForUpdates: `업데이트 확인 중…`,
      stateNotCheckedYet: `아직 확인하지 않음`,
      checkAgain: `다시 확인`,
      online: `온라인`,
      offline: `오프라인`,
      on: `켜짐`,
      off: `꺼짐`,
      stateOnline: `온라인`,
      stateOffline: `오프라인`,
      stateConnected: `연결됨`,
      stateDisconnected: `연결 끊김`,
      stateRegisteredReady: `등록 완료 및 준비됨`,
      stateConnecting: `연결 중…`,
      stateReconnecting: `재연결 중`,
      stateSuspended: `일시 중단됨`,
      stateRegistrationError: `등록 오류`,
      regNotStarted: `시작되지 않음`,
      regRegistered: `등록됨`,
      regUnregistered: `등록 해제됨`,
      regTerminated: `종료됨`,
      transportNotStarted: `시작되지 않음`,
      transportConnected: `연결됨`,
      transportDisconnected: `연결 끊김`,
      sectionSip: `SIP`,
      sectionMessaging: `메시지 / 실시간`,
      sectionNetwork: `네트워크`,
      sectionTelephony: `전화`,
      sectionEnvironment: `환경`,
      labelRegistration: `등록`,
      labelTransport: `전송`,
      labelLastError: `마지막 오류`,
      labelWebSocket: `WebSocket`,
      labelLastHeartbeat: `마지막 하트비트`,
      heartbeatAgo: `{{seconds}}초 전`,
      heartbeatStale: `{{seconds}}초 전 (오래됨)`,
      heartbeatNone: `아직 없음`,
      labelReconnectAttempts: `재연결 시도`,
      labelBrowser: `브라우저`,
      sectionAudio: `오디오`,
      labelMicPermission: `마이크 권한`,
      labelMicInput: `마이크 (입력)`,
      labelSpeaker: `스피커 (출력)`,
      deviceCount: `{{count}}개 발견`,
      deviceDefault: `시스템 기본값`,
      deviceNone: `감지되지 않음`,
      sectionCall: `활성 통화`,
      callNone: `활성 통화 없음`,
      labelCallStatus: `상태`,
      labelCallDirection: `방향`,
      labelCallSource: `소스`,
      labelCallHold: `보류 중`,
      labelCallMuted: `음소거됨`,
      labelCallDuration: `통화 시간`,
      labelLatestVersion: `최신 버전`,
      labelUpToDate: `최신 상태`,
      labelOutOfDate: `업데이트 가능`,
      labelChannel: `채널`,
      labelPlatform: `플랫폼`,
      sectionSession: `세션`,
      labelSignedIn: `로그인됨`,
      labelTokenExpiry: `세션 만료`,
      tokenExpired: `만료됨`,
      tokenValid: `유효함`,
      tokenNone: `활성 세션 없음`,
      labelNotifications: `알림`,
      labelLocalStorage: `로컬 저장소`,
      storageWritable: `쓰기 가능`,
      storageBlocked: `차단됨`,
      navChipDegraded: `앱 상태: 확인 필요`,
      navChipDown: `앱 상태: 문제 발견`,
      navChipAria: `문제가 감지되었습니다. 앱 상태 열기.`,
      sectionEvents: `최근 연결 이벤트`,
      noEvents: `이 세션에서 연결 변경이 없습니다 — 연결이 안정적으로 유지되었습니다.`,
      eventOnline: `네트워크 온라인`,
      eventOffline: `네트워크 오프라인`,
      eventWsConnected: `실시간 연결됨`,
      eventWsReconnecting: `실시간 재연결 중`,
      eventWsSuspended: `실시간 일시 중단됨`,
      eventWsDisconnected: `실시간 연결 끊김`,
      labelPbx: `PBX`,
      labelPbxId: `PBX ID`,
      labelPbxUuid: `PBX UUID`,
      labelDoNotDisturb: `방해 금지`,
      labelRespondBusy: `두 번째 통화에 통화 중 응답`,
      labelAppVersion: `앱 버전`,
      labelBuild: `빌드`,
      labelCaptured: `캡처 시간`,
      labelUserAgent: `사용자 에이전트`,
      extensions: `내선번호`,
      noExtensions: `할당된 내선번호가 없습니다.`,
      thisSession: `현재 세션`,
    },

    contactsPage: {
      emptyDetailMessage: `선택된 연락처 없음`,
      toast: {
        copyNumberSuccess: `전화번호가 클립보드에 복사되었습니다.`,
        copyNumberError: `전화번호를 복사할 수 없습니다.`,
      },
    },

    contactsListView: {
      searchPlaceholder: `이름 또는 번호 검색`,
      searchLabel: `연락처 검색`,
      contactSourceContent: `모든 연락처`,
      emptyNotice: {
        noContactsYet: `아직 연락처가 없습니다`,
        contactSupport: `환자 연락처를 연결하려면 지원팀에 문의하세요. 내부 내선 번호도 설정 후 여기에 표시됩니다.`,
        noContactsFound: `연락처를 찾을 수 없습니다`,
        noMatchingContacts: `일치하는 연락처를 찾을 수 없습니다`,
      },
    },

    contactItems: {
      primary: `기본`,
      actionButton: {
        copyNumber: `번호 복사`,
        callNumber: `번호로 전화 걸기`,
        messageNumber: `번호로 메시지 보내기`,
        sendFax: `팩스 보내기`,
        callNumberLabel: `{{number}}(으)로 전화 걸기`,
        messageNumberLabel: `{{number}}(으)로 메시지 보내기`,
        sendFaxLabel: `{{number}}(으)로 팩스 보내기`,
        copyNumberLabel: `{{number}} 복사`,
        unblockNumberLabel: `{{number}} 차단 해제`,
      },
      emptyContactItem: `이 연락처에 저장된 전화번호가 아직 없습니다.`,
      contactInformation: `연락처 정보`,
      contactSource: `연락처 출처:`,
      fromPms: `{{pmsName}} 발신`,
    },

    contactEventHistory: {
      recentActivity: `최근 활동`,
      timespanText: `지난 14일`,
      historyLabel: {
        messaging: `메시지 스레드`,
        inboundCall: `수신 통화`,
        outboundCall: `발신 통화`,
        inboundFax: `팩스 수신`,
        outboundFax: `팩스 전송`,
        voicemail: `음성 메일`,
      },
    },

    quickDialView: {
      tab: {
        favorites: `즐겨찾기`,
        recentlyDialed: `최근 발신`,
      },
      groupName: {
        parkingSpots: `주차 공간`,
        lineExtensions: `회선 내선`,
        speedDial: `단축 다이얼`,
      },
      phoneSettings: `전화 설정`,
    },

    quickDialListItem: {
      empty: {
        parkingSpots: `여기에 주차 공간을 표시하려면 웹 전화 설정을 조정하십시오.`,
        lineExtensions: `사용 가능 여부를 확인하려면 회선 내선을 추가하십시오.`,
        speedDial: `자주 거는 번호를 단축 다이얼로 저장하십시오.`,
        recentlyDialedPrimary: `최근 발신 번호 없음`,
        recentlyDialedSecondary: `전화를 걸면 최근 발신 번호가 여기에 나타납니다.`,
      },
      button: {
        webPhoneSettings: `웹 전화 설정`,
        configurePresence: `재석 설정`,
        configureSpeedDial: `단축 다이얼 설정`,
      },
      parkingLot: {
        title: `주차 공간`,
        subtitle: `주차 공간`,
      },
      tooltip: {
        pickUpCall: `통화 받기`,
        startCall: `통화 시작`,
        parkCall: `통화 주차`,
        newCall: `새 통화 시작`,
        transferCall: `통화 전송`,
      },
    },

    callContactButton: {
      startCall: `통화 시작`,
      startCallAriaLabel: `통화 시작: {{name}}, {{number}}`,
      startCallNumberAriaLabel: `통화 시작: {{number}}`,
      callNumber: `{{number}}(으)로 전화`,
      callNumberWithLabel: `{{number}}(으)로 전화 - {{label}}`,
      otherNumbersAriaLabel: `{{name}}의 다른 번호`,
    },

    phoneNumberInput: {
      placeholder: `번호 입력`,
      clearButton: `지우기`,
      inputLabel: `전화할 번호`,
    },

    phoneNumberMultiDropdown: {
      allNumbers: `모든 번호`,
    },

    phoneSearchInput: {
      placeholder: `이름 또는 번호 입력`,
      clearButton: `지우기`,
      inputLabel: `이름 또는 번호로 검색`,
    },

    contactCardsList: {
      emptySearchText: `검색을 시작하려면 위에 이름 또는 번호를 입력하십시오.`,
    },

    outOfCallView: {
      tabButtonDialpad: `다이얼패드`,
      tabButtonSearch: `검색`,
    },

    contactCardList: {
      searchResults: `검색 결과`,
      noMatchingContacts: `일치하는 연락처를 찾을 수 없습니다. `,
    },

    callButton: {
      startCall: `통화 시작`,
      endCall: `통화 종료`,
      disabled: `비활성화됨`,
      unknown: `알 수 없음`,
    },

    callControlButton: {
      endCall: `통화 종료`,
      splitConference: `회의 분할`,
      mergeCalls: `통화 병합`,
      newCall: `새 통화`,
      transfer: `전송`,
      park: `주차`,
      mute: `음소거`,
      keypad: `키패드`,
      hold: `보류`,
      audioSettings: `오디오 설정`,
    },

    onboardingView: {
      welcomeText: `어떤 브라우저에서든 통화 가능`,
      bodyText: `전화 걸기 및 받기, 쉽게 전송 또는 주차, 여러 통화 관리, 즐겨찾기 및 단축 다이얼 추가. 언제 어디서든 당신의 방식으로 소통하십시오.`,
      buttonLabel: `전화 활성화`,
      confirmModal: {
        title: `사용 가능한 회선 내선 없음`,
        message1: `이 전화 시스템({{pbxName}})에 할당된 회선 내선이 없습니다.`,
        message2: `전화 기능을 사용하려면 시스템 관리자에게 문의하여 회선 내선을 할당하십시오.`,
        confirmText: `해제`,
      },
    },

    numberComparisonDashboard: {
      invalidDateRange: `잘못된 날짜 범위`,
      dateRangeTooLarge: `날짜 범위가 너무 큽니다. 365일 이하의 범위를 선택하세요.`,
      dateRangeAdjustPrompt: `날짜 범위를 조정한 후 다시 시도하세요.`,
      chartTitle: `번호별 통화량`,
      showingCount: `{{total}}개 중 {{displayed}}개 표시`,
      counters: {
        totalCalls: {
          title: `총 수신 통화`,
          subtitle: `모든 번호의 총 수신 통화`,
        },
        numberCount: {
          title: `총 번호 수`,
          subtitle: `추적된 총 전화번호 수`,
        },
        averageCalls: {
          title: `번호당 평균`,
          subtitle: `번호당 평균 수신 통화`,
        },
        topNumber: {
          title: `최고 실적`,
        },
      },
      dashboard: {
        errorText: `번호 데이터 로드 오류`,
        noDataText: `사용 가능한 번호 데이터 없음`,
      },
      showMore: `더 보기 ({{remaining}}개 남음)`,
      unknown: `알 수 없음`,
      notAvailable: `해당 없음`,
    },

    callControl: {
      audioSettings: {
        title: `오디오 설정`,
        outputSource: `출력 소스 - 스피커`,
        inputSource: `입력 소스 - 마이크`,
      },
      parkCall: `통화 주차`,
      transferCall: `통화 전송`,
    },

    transferTarget: {
      buttonText: `통화 전송`,
      buttonAriaLabel: `통화 전송: {{name}}, {{number}}`,
    },

    transferHeader: {
      placeholder: `번호 입력`,
      ariaLabel: `전송`,
      inputLabel: `전송할 번호`,
    },

    parkTarget: {
      buttonText: `통화 주차`,
      buttonAriaLabel: `통화 주차: {{name}}`,
    },

    controlDrawer: {
      ariaLabel: `서랍 닫기`,
    },

    dashboardsPage: {
      item: {
        agentStatus: `에이전트 상태`,
        eventLog: `이벤트 로그`,
        inboundAnswerRate: `인바운드 응답률`,
        numberComparison: `번호 비교`,
        extensionComparison: `내선 비교`,
        queueDashboard: `대기열 대시보드`,
      },
      group: {
        callCenter: `콜 센터`,
        callDashboards: `통화 대시보드`,
      },
    },

    queueDashboard: {
      emptyState: {
        title: `정보를 찾을 수 없습니다`,
        description: `관련 데이터를 보려면 목록에서 대기열을 선택하세요`,
      },
      filters: {
        title: `대기열`,
        subtitle: `팀의 통화 활동을 비교해보세요`,
      },
      queueSelector: {
        placeholder: `목록에서 선택`,
        ariaLabel: `통화 대기열 선택`,
      },
      metrics: {
        callersInQueue: `대기열의 통화자`,
        maxWait: `최대 대기 시간`,
        averageWait: `평균 대기 시간`,
        maxAbandoned: `최대 포기`,
        averageAbandoned: `평균 포기`,
        dropRate: `포기율`,
        answerRate: `응답률`,
        sampleHistory: `샘플 기록`,
        sampleHistoryAriaLabel: `샘플 기록 시간 창 선택`,
      },
      agentsPanel: {
        title: `에이전트 대기열`,
        activeAgents: `활성 에이전트`,
        inactiveAgents: `비활성 에이전트`,
        searchPlaceholder: `이름 또는 내선 입력`,
        exportCsv: `CSV 내보내기`,
        exportToast: {
          title: `내보내기`,
          description: `CSV 내보내기 기능이 곧 제공될 예정입니다.`,
        },
        loginFailed: {
          title: `로그인 실패`,
          description: `에이전트를 대기열에 로그인하지 못했습니다. 다시 시도해주세요.`,
        },
        logoutFailed: {
          title: `로그아웃 실패`,
          description: `에이전트를 대기열에서 로그아웃하지 못했습니다. 다시 시도해주세요.`,
        },
      },
      callersTable: {
        title: `인바운드 대기열`,
        callerNumber: `통화자 번호`,
        callerName: `통화자 이름`,
        callTime: `통화/대기 시간`,
        status: `상태`,
        emptyState: {
          title: `정보를 찾을 수 없습니다`,
          description: `현재 대기열에 표시할 정보가 없습니다`,
        },
      },
      activeAgentsTable: {
        callerNumber: `통화자 번호`,
        agentName: `에이전트 이름`,
        ext: `내선`,
        loggedIn: `로그인됨`,
        talkTime: `통화 시간`,
        answered: `응답`,
        missed: `누락`,
        total: `전체`,
        status: `상태`,
        lastOffered: `마지막 제공`,
        action: `작업`,
        emptyState: {
          title: `에이전트를 찾을 수 없습니다`,
          description: `현재 대기열에 표시할 정보가 없습니다`,
        },
      },
      inactiveAgentsTable: {
        agent: `에이전트`,
        ext: `내선`,
        lastLoggedOut: `마지막 로그아웃`,
        status: `상태`,
        action: `작업`,
        emptyState: {
          title: `에이전트를 찾을 수 없습니다`,
          description: `현재 대기열에 표시할 정보가 없습니다`,
        },
      },
      agentRow: {
        changeStatus: `상태 변경`,
        offline: `오프라인`,
      },
      settings: {
        alertHoldTime: `대기 알림 시간`,
        alertHoldTimeAriaLabel: `대기 알림 임계값 선택`,
        refreshEvery: `다음마다 새로고침`,
        refreshAriaLabel: `새로고침 간격 선택`,
        seconds_one: `{{count}}초`,
        seconds_other: `{{count}}초`,
        minutes_one: `{{count}}분`,
        minutes_other: `{{count}}분`,
        hours_one: `{{count}}시간`,
        hours_other: `{{count}}시간`,
      },
      errorDisplay: {
        retrying_one: `{{count}}초 후 재시도...`,
        retrying_other: `{{count}}초 후 재시도...`,
        retryNow: `지금 재시도`,
        retryingButton: `재시도 중...`,
        persistentMessage: `반복적인 실패로 인해 자동 새로고침이 일시 중지되었습니다.`,
      },
      status: {
        ready: `준비됨`,
        onCall: `통화 중`,
        ringing: `벨 울림`,
        available: `사용 가능`,
        break: `휴식`,
        waiting: `대기 중`,
        answered: `응답됨`,
        cancelled: `취소됨`,
      },
    },

    inboundAnswerRate: {
      header: `수신 응답률`,
      subtitle: `응답된 수신 통화의 비율을 표시합니다`,
      filters: {
        dateRange: `날짜 범위`,
        number: `번호`,
        maxPhoneNumbers: `(최대 {{max}})`,
      },
      counters: {
        answerRate: {
          title: `응답률`,
          subtitle: `응답된 통화 비율`,
        },
        totalCalls: {
          title: `총 통화`,
          subtitle: `총 수신 통화`,
        },
        answered: {
          title: `응답된 통화`,
          subtitle: `총 응답된 통화`,
        },
        missed: {
          title: `부재중 통화`,
          subtitle: `총 부재중 통화`,
        },
      },
      dashboard: {
        title: `응답률 통계`,
        errorText: `통화 데이터를 로드하는 데 오류가 발생했습니다.`,
        noDataText: `통화 데이터 없음`,
        tableViewPlaceholder: `테이블 뷰 곧 제공 예정`,
      },
      metrics: {
        answered: `응답됨`,
        missed: `부재 중`,
        answerRate: `응답률`,
      },
      rechartTitle: `{{groupByTitle}}당 통화`,
      viewToggle: {
        chart: `차트`,
        table: `테이블`,
      },
      table: {
        columns: {
          number: `번호`,
          answerRate: `수신 응답률`,
          answered: `응답된 통화`,
          missed: `부재중 통화`,
          total: `총 통화`,
        },
        errorLoading: `전화번호 통계를 불러오는 중 오류가 발생했습니다`,
        noData: `전화번호 데이터가 없습니다`,
        unknown: `알 수 없음`,
      },
      invalidDateRange: `잘못된 날짜 범위`,
      dateRangeTooLarge: `날짜 범위가 너무 큽니다. 365일 이하의 범위를 선택하세요.`,
      dateRangeAdjustPrompt: `날짜 범위를 조정한 후 다시 시도하세요.`,
    },

    voicemailLineChart: {
      rechartTitle: `{{groupByTitle}}당 음성 메일`,
    },

    agentStatusFilters: {
      header: `상담원 상태`,
      availability: `사용 가능 여부`,
      status: `상태`,
      items: {
        online: `온라인`,
        away: `자리 비움`,
      },
    },

    agentStatusTable: {
      agent: `상담원`,
      extension: `내선`,
      currentStatus: `현재 상태`,
      timeInStatus: `상태 유지 시간`,
      startedAt: `시작 시간`,
      actions: `작업`,
      status: {
        offline: `오프라인`,
        inQueue: `대기 중`,
      },
    },

    agentStatusActions: {
      tooltip: {
        changeStatus: `상태 변경`,
      },
    },

    eventLog: {
      title: `이벤트 로그`,
      filters: {
        allAgents: `모든 상담원`,
        searchAgents: `상담원 검색`,
      },
    },

    eventLogTable: {
      when: `언제`,
      who: `누가`,
      status: `상태`,
      inQueue: `대기 중`,
      changedBy: `변경한 사람`,
      yes: `예`,
      no: `아니오`,
      system: `시스템`,
      unknown: `알 수 없음`,
      failedToLoad: `이벤트를 추가로 불러오지 못했습니다.`,
      retry: `다시 시도`,
      noRecords: `기록이 없습니다.`,
      noRecordsHint: `필터를 조정하거나 지우면 더 많은 항목을 볼 수 있습니다.`,
    },

    callDetailsOverviewTab: {
      missed: `부재 중`,
      answered: `응답됨`,
      textButton: `음성 메일 녹음됨`,
    },

    callDetailData: {
      missed: `부재 중`,
      answered: `응답됨`,
      inProgress: `진행 중`,
      failed: `실패`,
      direction: {
        inbound: `수신`,
        outbound: `발신`,
        internal: `내선`,
      },
    },

    callFilters: {
      buttonTitle: `필터`,
      sections: {
        direction: `방향`,
        outcome: `결과`,
        sentiment: `감정`,
        status: `상태`,
        callTrait: `통화 특성`,
        duration: `지속 시간`,
        user: `사용자`,
        aiAgent: `AI 에이전트`,
      },
      direction: {
        inbound: `수신`,
        outbound: `발신`,
        internal: `내선`,
      },
      outcome: {
        missed: `부재 중`,
        answered: `응답됨`,
      },
      sentiment: {
        office: `사무실`,
        patient: `환자`,
        negative: `부정적`,
        neutral: `중립적`,
        positive: `긍정적`,
      },
      status: {
        inProgress: `진행 중`,
        completed: `완료됨`,
        failed: `실패`,
        canceled: `취소됨`,
        busy: `통화 중`,
      },
      callTrait: {
        voicemailRecorded: `음성 메일 녹음됨`,
        externallyTransferred: `외부 전환됨`,
      },
      duration: {
        longerThan: `보다 길게`,
        shorterThan: `보다 짧게`,
        tenSeconds: `10초`,
        oneMinute: `1분`,
        fiveMinutes: `5분`,
        tenMinutes: `10분`,
      },
      user: {
        unknown: `알 수 없는 사용자`,
      },
      aiAgent: {
        unknown: `알 수 없는 AI 에이전트`,
      },
    },

    rechartsBarChart: {
      tooltip: {
        modalView: `모달 보기`,
        answerRate: `응답률:`,
        total: `합계:`,
      },
      noChartData: `차트 데이터 없음`,
      weekOf: `{{date}} 주`,
    },

    dateDropdown: {
      today: `오늘`,
      yesterday: `어제`,
      last7Days: `지난 7일`,
      last14Days: `지난 14일`,
      last30Days: `지난 30일`,
      thisWeek: `이번 주`,
      lastWeek: `지난 주`,
      thisMonth: `이번 달`,
      lastMonth: `지난 달`,
      last60Days: `지난 60일`,
      last90Days: `지난 90일`,
      customRange: `사용자 지정 범위`,
    },

    dateTimeRange: {
      after: `이후: {{date}}`,
      before: `이전: {{date}}`,
      selectDateRange: `날짜 범위 선택`,
      buttonPlaceholder: `날짜 범위 선택`,
    },

    dateTimeRangeModal: {
      after: `이후 `,
      before: `이전 `,
      optional: `(선택 사항)`,
      selectDateRange: `날짜 범위 선택`,
      buttonPlaceholder: `날짜 범위 선택`,
      clearButton: `지우기`,
      setDateRangeButton: `날짜 범위 설정`,
      monthLabel: `{{label}} 월`,
      dayLabel: `{{label}} 일`,
      yearLabel: `{{label}} 연도`,
      hourLabel: `{{label}} 시`,
      minuteLabel: `{{label}} 분`,
      meridiemLabel: `{{label}} 오전/오후`,
    },

    queueControlButton: {
      inQueue: `대기 중`,
      outOfQueue: `대기 외`,
      doNotDisturb: `방해 금지`,
      online: `온라인`,
      offline: `오프라인`,
      joinQueue: `참여`,
      leaveQueue: `나가기`,
      goOffline: `오프라인`,
    },

    queueStatusMenu: {
      online: `온라인`,
      away: `자리 비움`,
      goOffline: `오프라인`,
      joinQueue: `대기 중`,
    },

    changelogModal: {
      whatsNewLabel: `새로운 기능`,
      noResults: `변경 로그를 사용할 수 없습니다`,
      doneButton: `완료`,
      loadingData: `변경 로그를 로드 중...`,
      latest: `(최신)`,
      releasedLabel: `출시됨`,
    },

    queueToasts: {
      loggedInToQueue: `대기열에 로그인됨`,
      loggedOutOfQueue: `대기열에서 로그아웃됨`,
      agentStatusUpdated: `상담원 상태 업데이트됨`,
      unableToUpdateStatus: `상태를 업데이트할 수 없음`,
      queueUpdateErrorMessage: `이 사용자/내선이 관리자 포털의 통화 대기열에 추가되었는지 확인하거나 지원팀에 문의하세요.`,
      genericUpdateErrorMessage: `상태를 업데이트하는 중 문제가 발생했습니다. 다시 시도하거나 지원팀에 문의하세요.`,
      ok: `확인`,
    },

    regionSelector: {
      settingsTitle: `망고 데이터 지역`,
      settingsDescription: `이는 망고 생태계 내에서 귀하의 데이터가 보관되는 지역을 나타냅니다.`,
      selectRegion: `지역 선택`,
      regionInfoTooltip: `망고 데이터 지역을 나타내며, 귀하의 위치가 아닙니다.`,
      regions: {
        unitedStates: `미국`,
        unitedKingdom: `영국`,
      },
    },

    announcementBanner: {
      infoLabel: `정보 공지: {{title}}`,
      warningLabel: `경고 공지: {{title}}`,
      criticalLabel: `긴급 공지: {{title}}`,
      dismiss: `공지 닫기`,
      collapse: `공지 접기`,
      expand: `공지 펼치기`,
    },
    bannerPager: {
      carousel: `배너`,
      slide: `배너 {{total}}개 중 {{current}}번째`,
      position: `{{current}}/{{total}}`,
      previous: `이전 배너`,
      next: `다음 배너`,
      carouselRole: `캐러셀`,
      slideRole: `슬라이드`,
    },

    appVersionBanner: {
      desktopUpdateAvailable: `{{appName}} 버전 {{version}}을(를) 사용할 수 있습니다!`,
      webUpdateAvailable: `새로운 Mango 웹 앱 버전을 사용할 수 있습니다!`,
      restartAndUpdate: `재시작 및 업데이트`,
      updateNow: `지금 업데이트`,
      whatsNew: `새로운 기능`,
      remindLater: `나중에 알림`,
      dismiss: `닫기`,
    },

    clockSkewBanner: {
      message: `기기의 시계가 몇 분 이상 어긋나 있습니다. 이로 인해 통화, 메시지 및 기타 기능이 예기치 않게 작동할 수 있습니다. 시스템 설정에서 날짜 및 시간 자동 동기화를 켜 주세요.`,
    },

    updateBlockedBanner: {
      message: `앱이 업데이트를 완료하지 못했습니다. 보통 백신 또는 보안 소프트웨어가 업데이트를 차단하기 때문입니다. IT 담당자에게 앱 업데이트를 허용하도록 요청하거나 최신 버전을 다운로드하세요.`,
      downloadLatest: `최신 버전 다운로드`,
    },

    updatePermissionBanner: {
      message: `앱이 설치된 방식 때문에 이 컴퓨터에서 업데이트를 설치할 수 없습니다. 도움말 문서를 따르거나 IT 담당자와 공유하세요.`,
      howToFix: `해결 방법`,
      updateAnyway: `그래도 업데이트`,
    },

    updateCheck: {
      checkForUpdates: `업데이트 확인`,
      restartAndUpdate: `재시작 및 업데이트`,
      checking: `업데이트 확인 중...`,
      upToDate: `앱이 최신 버전입니다`,
      checkFailed: `업데이트 확인 실패`,
      versionAvailable: `버전 {{version}}을(를) 사용할 수 있습니다`,
      downloading: `다운로드 중... {{percent}}%`,
      downloaded: `버전 {{version}} 다운로드 완료`,
      errorOccurred: `업데이트 확인 중 오류가 발생했습니다.`,
    },
    updateRequirement: {
      recommendedMessage: `{{appName}}의 새 버전을 사용할 수 있습니다. 최신 수정 사항을 받으려면 업데이트하세요.`,
      recommendedMessageWithDate: `계속 사용하려면 {{date}}까지 {{appName}}을(를) 업데이트하세요.`,
      requiredDuringCall: `이 버전의 {{appName}}은(는) 더 이상 지원되지 않습니다. 통화가 끝나면 계속 사용하려면 업데이트해야 합니다.`,
      update: `업데이트`,
      later: `나중에`,
      downloading: `다운로드 중 {{percent}}%`,
      restartToUpdate: `다시 시작하여 업데이트`,
      downloadInstaller: `설치 프로그램 다운로드`,
      requiredTitle: `업데이트 필요`,
      requiredMessage: `이 버전의 {{appName}}({{currentVersion}})은(는) 더 이상 지원되지 않습니다. 앱을 계속 사용하려면 업데이트하세요.`,
      callsNotice: `업데이트하기 전까지 이 앱은 전화를 받을 수 없습니다. 전화는 다른 기기, 링 그룹 또는 음성 사서함으로 연결됩니다.`,
      preparing: `업데이트 준비 중...`,
      downloadingProgress: `업데이트 다운로드 중: {{percent}}%`,
      progressLabel: `업데이트 다운로드 진행률`,
      manualInstallMessage: `앱이 업데이트를 자동으로 설치할 수 없습니다. 최신 버전을 다운로드하여 설치하세요.`,
      useWebApp: `웹 앱 사용`,
      contactSupport: `지원팀에 문의`,
      alertTitle: `{{appName}} 업데이트가 필요합니다`,
      alertBody: `업데이트할 때까지 전화는 다른 기기 또는 음성 사서함으로 연결됩니다.`,
      copyDownloadLink: `다운로드 링크 복사`,
      linkCopied: `링크가 복사되었습니다`,
    },

    callDetails: {
      title: `통화 상세정보`,
      callTimeline: `통화 타임라인`,
      callFlow: `통화 흐름`,
      started: `시작됨`,
      ended: `종료됨`,
      answerTime: `응답 시간`,
      callDuration: `통화 시간`,
      callOn: `통화 일시`,
      statisticsNotAvailable: `통계를 사용할 수 없습니다`,
      transcriptNotAvailable: `녹취록을 사용할 수 없습니다`,
      noRecordingAvailable: `녹음이 없습니다`,
      callSummary: `통화 요약`,
      callStatistics: `통화 통계`,
      header: {
        copyLinkToCall: `통화 링크 복사`,
        copyLinkToCallAtTimestamp: `타임스탬프에서 통화 링크 복사`,
        downloadAudio: `오디오 다운로드`,
        closePanel: `패널 닫기`,
        expand: `확장`,
        moreActions: `더 많은 작업`,
      },
      sections: {
        sentimentByQuarter: {
          title: `분기별 감정`,
          tooltip: `환자와 사무실의 감정을 보여주며 대화의 감정적 톤을 반영합니다. 각 분기는 긍정적(녹색), 중립적(회색) 또는 부정적(빨간색)으로 분류됩니다.`,
          agentOverall: `에이전트: {{score}} 전체`,
          customerOverall: `고객: {{score}} 전체`,
          patient: `환자`,
          office: `사무실`,
        },
        officeTalkTime: {
          title: `사무실 통화 시간`,
          tooltip: `이 원형 차트는 통화 중 사무실이 말하는 시간과 듣는 시간의 분석을 보여줍니다. 이상적으로 에이전트는 말하는 것보다 듣는 데 더 많은 시간을 보내야 하며, 효과적인 고객 상호작용을 위해 50-60% 말하기와 40-50% 듣기 분할을 목표로 해야 합니다.`,
          talking: `말하기`,
          listening: `듣기`,
        },
        officeTalkSpeed: {
          title: `사무실 말하기 속도`,
          tooltip: `이것은 분당 단어 수(wpm)로 사무실의 전체 말하기 속도를 보여줍니다. 정상 범위는 120-150 wpm으로 명확하고 이해하기 쉽습니다. 100 wpm 미만의 속도는 너무 느리게 느껴질 수 있으며, 160 wpm 이상의 속도는 환자가 따라가기 어려울 수 있습니다.`,
          wordsPerMinute: `분당 단어 수`,
        },
        interruptions: {
          title: `방해`,
          tooltip: `환자와 사무실이 서로 방해한 횟수를 보여줍니다. 대화가 얼마나 원활하게 진행되었는지 평가하는 데 유용합니다.`,
          total: `총계`,
          patient: `환자`,
          office: `사무실`,
        },
        holdAndPauseTime: {
          title: `대기 시간 및 일시 정지`,
          tooltip: `통화자가 대기하거나 침묵 상태로 보낸 시간과 전체 통화의 비율을 보여줍니다. 정상보다 긴 대기 시간은 빨간색으로 강조 표시됩니다.`,
          percentageOfCall: `통화의 {{percentage}}%`,
        },
      },
      toast: {
        linkCopied: `링크가 클립보드에 복사됨`,
        linkCopyFailed: `클립보드에 링크 복사 실패.`,
        voicemailTranscriptCopied: `음성 메일 녹취록이 클립보드에 복사됨.`,
        voicemailTranscriptCopyFailed: `음성 메일 녹취록을 복사할 수 없습니다.`,
        noVoicemailTranscript: `복사할 음성 메일 녹취록이 없습니다.`,
        voicemailTranscriptCopyError: `음성 메일 녹취록을 복사할 수 없습니다. 다시 시도해 주세요.`,
        summaryCopied: `요약이 클립보드에 복사됨.`,
        summaryCopyFailed: `요약을 복사할 수 없습니다. 다시 시도해 주세요.`,
        noSummary: `복사할 요약이 없습니다.`,
        feedbackThanks: `피드백 감사합니다!`,
        feedbackThumbsUpFailed: `좋아요 작업 보고 실패.`,
        feedbackThumbsDownFailed: `싫어요 작업 보고 실패.`,
      },
      voicemail: {
        title: `음성 메일`,
        loading: `음성 메일 녹취록 로딩 중...`,
        accessDenied: `이 음성 메일은 접근 권한이 없는 수신함에 남겨졌습니다. 시스템 관리자에게 문의하세요.`,
        deleted: `음성 메일이 삭제되었습니다.`,
        notAvailable: `음성 메일을 사용할 수 없습니다.`,
        transcriptionNotAvailable: `음성 메일 녹취록을 사용할 수 없습니다.`,
      },
      summary: {
        title: `요약`,
        processing: `통화 녹취록 처리 중...`,
        notFound: `요약을 찾을 수 없음`,
        notAvailable: `녹취록 요약을 사용할 수 없습니다.`,
      },
      margoSummary: {
        title: `Margo 요약`,
        copy: `Margo 요약 복사`,
        copied: `Margo 요약 복사됨`,
        copySuccess: `Margo 요약이 클립보드에 복사되었습니다.`,
        copyFailure: `Margo 요약을 복사할 수 없습니다. 다시 시도해 주세요.`,
      },
      tabs: {
        overview: `개요`,
        transcripts: `녹취록`,
        stats: `통계`,
      },
      sentiment: {
        title: `감정`,
        patient: `환자`,
        office: `사무실`,
        positive: `긍정적`,
        negative: `부정적`,
        neutral: `중립적`,
      },
      tooltip: {
        copyToClipboard: `클립보드에 복사`,
        goToVoicemail: `음성 메일로 이동`,
        accurate: `정확함`,
        inaccurate: `부정확함`,
        copyLinkToSearch: `검색 링크 복사`,
        fullscreen: `전체 화면`,
      },
    },

    calls: {
      searchLabel: `통화 검색`,
      export: {
        button: `CSV 내보내기`,
        starting: `시작 중...`,
        preparing: `내보내기 준비 중...`,
        processing: `내보내는 중...`,
        completed: `내보내기 완료`,
        success: `CSV 다운로드가 시작되었습니다`,
        successTruncated: `내보내기 완료 (결과가 100만 행으로 제한됨)`,
        error: `내보내기 실패`,
        errorTooMany: `너무 많은 내보내기가 실행 중입니다. 잠시 후 다시 시도해 주세요.`,
        errorInvalid: `잘못된 내보내기 매개변수입니다.`,
        errorNotFound: `내보내기 작업을 찾을 수 없습니다. 서버가 재시작되었을 수 있습니다. 다시 시도해 주세요.`,
        errorGeneric: `내보내기를 시작할 수 없습니다.`,
        errorStatusCheck: `내보내기 상태를 확인할 수 없습니다.`,
        toastProcessingTitle: `내보내기 진행 중`,
        toastProcessingDescription: `CSV가 준비되고 있습니다. 다운로드가 자동으로 시작됩니다.`,
        unsupportedFiltersHeader: `CSV 내보내기에서 지원하지 않는 필터:`,
        filterSearch: `검색`,
      },
      transcriptCell: {
        noTranscriptAvailable: `대화록을 사용할 수 없습니다.`,
        inProgress: `대화록이 생성 중입니다. 나중에 다시 확인해 주세요.`,
        audioTooLong: `대화록을 사용할 수 없습니다. 통화 오디오가 너무 깁니다.`,
        viewTranscript: `대화록 보기`,
        noTranscript: `대화록을 사용할 수 없습니다`,
        transcriptInProgress: `대화록 생성 중`,
        transcriptUnavailable: `대화록을 사용할 수 없음`,
        openVoicemail: `음성 메일 열기`,
      },
      detail: {
        notFound: `이 기록이 삭제되었거나 존재하지 않습니다. 도움이 필요하면 지원팀에 문의하세요.`,
        unknownNumber: `알 수 없는 번호`,
        unknownSource: `알 수 없음`,
      },
    },

    missedCalls: {
      emptyState: `부재중 전화 없음`,
      emptyStateSubtitle: `모든 전화가 응답됨`,
      description: `부재중 전화 추적 및 관리`,
      instructions: `필터와 날짜 범위를 사용하여 특정 부재중 전화를 찾으세요`,
      errorLoadingMissedCalls: `부재중 전화 로딩 오류`,
      pleaseTryAgainLater: `나중에 다시 시도해 주세요`,
      countLabel: `{{count}} 부재중 전화`,
      refresh: `새로고침`,
      followUpStatus: {
        open: `열림`,
        returnedCallBack: `반환됨 - 다시 전화`,
        returnedSMS: `반환됨 - SMS`,
        returnedVoicemail: `반환됨 - 음성 메일`,
        returnedEmail: `반환됨 - 이메일`,
        returnedNoAnswer: `반환됨 - 응답 없음`,
        noFollowUpRequired: `후속 조치 불필요`,
        assignUserFirst: `먼저 사용자를 할당하세요`,
      },
      filters: {
        sections: {
          type: `유형`,
          status: `상태`,
          user: `사용자`,
          phoneNumber: `전화번호`,
        },
        type: {
          voicemail: `음성 메일`,
          abandoned: `부재`,
        },
        userFallback: `사용자 {{id}}`,
      },
      assignedUser: {
        loading: `로딩 중...`,
        loadingShort: `로딩 중`,
        unassigned: `미할당`,
        userFallback: `사용자 {{id}}`,
      },
      type: {
        voicemailAlt: `음성 메일`,
        abandonedAlt: `부재`,
        abandonedTitle: `부재`,
        abandonedDescription: `통화가 응답되지 않았고 고객이 음성 메일을 남기지 않았습니다`,
      },
    },

    callsList: {
      noCallsFound: `전화 기록 없음`,
      tryDifferentFilters: `다른 필터를 시도해 보세요`,
    },

    callsTable: {
      label: `통화`,
      openCallDetails: `통화 세부 정보 보기, {{time}} {{date}}`,
      columns: {
        dateTime: `날짜 및 시간`,
        outcome: `결과`,
        to: `받는 사람`,
        from: `보낸 사람`,
        toFrom: `받는 사람/보낸 사람`,
        duration: `지속 시간`,
        transcript: `녹취록`,
      },
    },

    missedCallsTable: {
      columns: {
        dateTime: `날짜 및 시간`,
        from: `보낸 사람`,
        to: `받는 사람`,
        type: `유형`,
        followUpTime: `후속 시간`,
        followUpStatus: `후속 상태`,
        assignedTo: `할당 대상`,
        action: `작업`,
      },
    },

    contactInfoCard: {
      callTarget: {
        from: `보낸 사람`,
        to: `받는 사람`,
      },
      tooltip: {
        call: `통화`,
        message: `메시지`,
        sendFax: `팩스 보내기`,
        blockNumber: `번호 차단`,
        unblockNumber: `번호 차단 해제`,
      },
    },

    contactCell: {
      menu: {
        callNumber: `번호 통화`,
        copyNumber: `번호 복사`,
        messageNumber: `번호 메시지`,
        sendFax: `팩스 보내기`,
        blockNumber: `번호 차단`,
        unblockNumber: `번호 차단 해제`,
        moreOptions: `더 많은 옵션`,
        moreOptionsFor: `{{name}}에 대한 더 많은 옵션, {{time}} {{date}}`,
      },
    },

    reportingFilters: {
      dateRange: `날짜 범위`,
      number: `번호`,
      maxPhoneNumbers: `(최대 {{max}})`,
    },

    numberComparisonFilters: {
      numberComparison: `번호 비교`,
      subtitle: `전화번호별 수신 통화량 비교`,
      dateRange: `날짜 범위`,
      number: `번호`,
      maxPhoneNumbers: `(최대 {{max}})`,
    },

    numberComparisonTable: {
      columns: {
        name: `전화번호 이름`,
        number: `전화번호`,
        inboundCalls: `수신 통화`,
        avgDuration: `평균 통화 시간`,
      },
    },

    numberComparisonChart: {
      inboundCalls: `수신 통화`,
      avgDuration: `평균 통화 시간`,
    },

    extensionComparison: {
      retired: `폐지됨`,
    },

    extensionComparisonDashboard: {
      invalidDateRange: `잘못된 날짜 범위`,
      dateRangeTooLarge: `날짜 범위가 너무 큽니다. 365일 이하의 범위를 선택하세요.`,
      dateRangeAdjustPrompt: `날짜 범위를 조정한 후 다시 시도하세요.`,
      chartTitle: `내선별 통화량`,
      showingCount: `{{total}}개 중 {{displayed}}개 표시`,
      notAvailable: `해당 없음`,
      counters: {
        totalCalls: {
          title: `총 통화`,
          subtitle: `모든 내선의 총 통화`,
        },
        averageCalls: {
          title: `내선당 평균`,
          subtitle: `내선당 평균 통화`,
        },
        averageMinutes: {
          title: `내선당 평균 분`,
          subtitle: `내선당 평균 분`,
        },
        topExtension: {
          title: `최고 실적`,
        },
      },
      dashboard: {
        errorText: `내선 데이터 로드 오류`,
        noDataText: `사용 가능한 내선 데이터 없음`,
      },
    },

    extensionComparisonFilters: {
      title: `내선 비교`,
      subtitle: `내선별 통화량 비교`,
      directionLabel: `방향`,
      extensionsLabel: `내선`,
      direction: {
        all: `수신 및 발신`,
        inbound: `수신`,
        outbound: `발신`,
      },
    },

    extensionComparisonChart: {
      extensionLabel: `내선 {{ext}}`,
      totalCalls: `총 통화`,
      totalMinutes: `총 분`,
      avgDuration: `평균 통화 시간`,
      showMore: `더 보기 ({{remaining}}개 남음)`,
      totalCallsTitle: `총 통화`,
      totalMinutesTitle: `총 분`,
    },

    extensionComparisonTable: {
      columns: {
        extension: `내선`,
        calls: `통화`,
        percentCalls: `% 합계`,
        minutes: `분`,
        percentMinutes: `% 합계`,
      },
    },

    extensionMultiDropdown: {
      allExtensions: `모든 내선`,
    },

    extensionPills: {
      extensionsSelected: `{{count}}개 내선 선택됨`,
    },

    dashboards: {
      noDataAvailable: `사용 가능한 데이터 없음`,
      gettingPbx: `PBX 가져오는 중...`,
      noStatisticsAvailable: `사용 가능한 통계 없음`,
      noGridData: `그리드 데이터 없음`,
      errorLoadingStatistics: `통계 로딩 오류`,
      errorLoadingCallData: `통화 데이터 로딩 오류`,
      noCallDataAvailable: `사용 가능한 통화 데이터 없음`,
      errorLoadingVoicemailData: `음성 메일 데이터 로딩 오류`,
      noVoicemailDataAvailable: `사용 가능한 음성 메일 데이터 없음`,
      csvExport: {
        buttonLabel: `CSV 내보내기`,
        exported: `내보냄`,
        success: `CSV 내보내기 완료`,
        failed: `CSV 내보내기 실패`,
        headers: {
          inboundAnswerRate: {
            startDateTime: `시작 날짜/시간`,
            endDateTime: `종료 날짜/시간`,
            answeredCalls: `응답 통화`,
            missedCalls: `부재중 통화`,
            totalCalls: `전체 통화`,
            answerRatePercent: `응답률 %`,
          },
          numberComparison: {
            phoneNumber: `전화번호`,
            displayNumber: `표시 번호`,
            name: `이름`,
            inboundCalls: `수신 통화`,
            totalDurationSeconds: `총 통화 시간 (초)`,
            averageDurationSeconds: `평균 통화 시간 (초)`,
          },
          extensionComparison: {
            extension: `내선`,
            totalCalls: `총 통화`,
            totalMinutes: `총 분`,
            totalDurationSeconds: `총 통화 시간 (초)`,
            averageDurationSeconds: `평균 통화 시간 (초)`,
          },
        },
      },
      unknown: `알 수 없음`,
      notAvailable: `해당 없음`,
    },

    aria: {
      backspace: `백스페이스`,
      toggleColorMode: `색상 모드 전환`,
    },

    callAnalytics: {
      empty: {
        noTranscriptRecord: `이 통화에 대한 대화록 기록이 없는 것 같습니다.`,
        noCallSelected: `선택된 통화 없음`,
      },
      stats: {
        agentTalkTime: `상담원 발화 시간`,
        talking: `말하는 중: {{duration}} ({{percent}}%)`,
        listening: `듣는 중: {{duration}} ({{percent}}%)`,
        agentTalkSpeed: `상담원 발화 속도`,
        wordsPerMinute: `분당 {{count}}단어 (평균)`,
        holdTimeAndPauses: `대기 시간 및 일시 정지`,
        holdPercentOfCall: `{{duration}} (통화의 {{percent}}%)`,
        interruptionsTotal: `끼어들기: 총 {{count}}회`,
        interruptionsAgent: `상담원: {{count}} ({{percent}}%)`,
        interruptionsCustomer: `고객: {{count}} ({{percent}}%)`,
      },
      transcript: {
        office: `사무실`,
        patient: `환자`,
        silence: `침묵 {{duration}}`,
      },
    },

    filterModal: {
      header: `필터`,
      apply: `필터 적용`,
      clear: `지우기`,
      clearSection: `{{title}} 지우기`,
      buttonTitle: `필터`,
      tooltipOneApplied: `{{title}} (필터 {{count}}개 적용됨)`,
      tooltipManyApplied: `{{title}} (필터 {{count}}개 적용됨)`,
    },

    previewModal: {
      rotate: `회전`,
      imagePreview: `이미지 미리보기`,
    },

    pdfViewer: {
      loadError: `이 파일을 불러올 수 없습니다`,
    },

    mangoPlusAds: {
      stayRelevant: `관련성을 유지하세요`,
      inTodaysWorld: `오늘날의 세계에서`,
      bodyHeading: `문자를 싫어하는 사람이 있을까요?`,
      paragraph1: `오늘날 사람들은 전화보다 문자를 선호합니다. 고객에게 문자를 보내 시간과 에너지를 절약하세요!`,
      paragraph2: `문자는 Mango Plus의 여러 혜택 중 하나일 뿐입니다. 구매 전에 영업팀에 한 달 체험에 대해 문의하세요.`,
      learnMore: `자세히 알아보기`,
    },

    outboundPhoneSearch: {
      placeholder: `번호 선택`,
    },

    faxFilters: {
      directionTooltip: `방향 필터`,
      allFaxes: `모든 팩스`,
    },

    messagingThread: {
      dropFileToSend: `보낼 파일을 놓으세요`,
    },

    resetPassword: {
      togglePasswordVisibility: `비밀번호 표시 전환`,
    },

    resourceErrorBoundary: {
      defaultMessage: `예기치 않은 오류가 발생했습니다.`,
      notFoundFallback: `이 기록이 삭제되었거나 존재하지 않습니다. 도움이 필요하면 지원팀에 문의하세요.`,
      takeMeBack: `돌아가기`,
    },

    moveFaxModal: {
      toast: {
        errorMoving: `팩스를 이동하는 중 오류가 발생했습니다.`,
        notMarkedUnread: `팩스가 읽지 않음으로 표시되지 않았습니다.`,
        moveFailed: `선택한 가상 팩스로 팩스를 이동하지 못했습니다.`,
        errorTitle: `팩스 이동 오류`,
      },
      noAccessWarning: `선택한 가상 팩스에 대한 액세스 권한이 없으면 이동된 팩스를 볼 수 없습니다.`,
    },

    filePrinter: {
      printFailed: `파일 인쇄에 실패했습니다.`,
    },

    router: {
      loadingContent: `콘텐츠를 불러오는 중...`,
    },

    resourceFailedToLoad: {
      permission: `이 음성사서함에 액세스할 권한이 없습니다`,
      deleted: `음성메일이 삭제되었습니다`,
      unavailable: `음성메일을 사용할 수 없습니다`,
      contactAdmin: `액세스하려면 시스템 관리자에게 문의하세요`,
    },

    tagInput: {
      commaSeparated: `여러 값은 쉼표로 구분해야 합니다`,
      removeTag: `{{value}} 제거`,
      valueNotAdded: `이 값을 추가할 수 없습니다`,
      valuesNotAdded: `이 값들을 추가할 수 없습니다`,
      invalidValue: `이 값은 유효한 {{valueType}}이(가) 아닙니다`,
      invalidValues: `이 값들은 유효한 {{valueType}}이(가) 아닙니다`,
      limitReached: `최대 {{maxTags}}개에 도달했습니다. 다른 항목을 추가하려면 하나를 제거하세요.`,
      errorAndLimit: `{{error}}. {{limit}}`,
    },

    unsavedChangesDialog: {
      title: `저장되지 않은 변경 사항`,
      body: `저장되지 않은 변경 사항이 있습니다. 이 페이지를 떠나시겠습니까? 변경 사항이 손실됩니다.`,
      stay: `페이지에 머물기`,
      discard: `변경 사항 삭제`,
    },

    blockedNumber: {
      blockNumbers: `번호 차단`,
    },

    notificationsBanner: {
      grantedPrefix: `알림 환경설정은 다음에서 조정할 수 있습니다`,
      settings: `설정`,
      prompt: `Mango는 알림과 함께 사용할 때 가장 잘 작동합니다.`,
      enable: `알림 사용!`,
    },

    switchboardEdit: {
      invalidDialPlan: `잘못된 내선 다이얼 플랜`,
      invalidPbxId: `잘못된 PBX ID`,
      loading: `교환기를 불러오는 중...`,
    },

    webPhoneExtras: {
      activeCall: `진행 중인 통화`,
      failedSearch: `검색 실패`,
      otherLabel: `기타`,
      awayWithLabel: `자리 비움 - {{label}}`,
    },

    callDetailsExtras: {
      callInProgress: `통화 진행 중`,
      mayTakeMinutes: `몇 분이 걸릴 수 있습니다`,
    },

    contactCombinedCell: {
      fromPrefix: `발:`,
      toPrefix: `착:`,
    },

    messaging:
      messagingKo as unknown as (typeof en)['translation']['messaging'],
    phoneNumbers:
      phoneNumbersKo as unknown as (typeof en)['translation']['phoneNumbers'],
    pbxLocations:
      pbxLocationsKo as unknown as (typeof en)['translation']['pbxLocations'],
    musicOnHold:
      musicOnHoldKo as unknown as (typeof en)['translation']['musicOnHold'],
    hotels: hotelsKo as unknown as (typeof en)['translation']['hotels'],
    soundClips:
      soundClipsKo as unknown as (typeof en)['translation']['soundClips'],
    ...systemSettingsKo,
    pbxSettings:
      pbxSettingsKo as unknown as (typeof en)['translation']['pbxSettings'],
    devices: devicesKo as unknown as (typeof en)['translation']['devices'],
    extensions:
      extensionsKo as unknown as (typeof en)['translation']['extensions'],
    userGroups:
      userGroupsKo as unknown as (typeof en)['translation']['userGroups'],
    webhooks: webhooksKo as unknown as (typeof en)['translation']['webhooks'],
  },
  support_phone_label: `지원 핫라인: {{phoneNumber, phone}}`,
  user_profile_phone: `등록된 전화번호: {{userPhone, phone}}`,
} satisfies typeof en
